import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import firebase from 'firebase/app';
import { Http } from '@angular/http';
import { AngularFirestore } from 'angularfire2/firestore';
import html2canvas from 'html2canvas';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
//import * as jsPDF from 'jspdf'
import { LoadingProvider } from '../../providers/loading/loading';
import { ContactFormService } from '../edit-contact-form-list/services/contact-form.service';
import { FLOAT } from 'html2canvas/dist/types/css/property-descriptors/float';
//import { empty } from 'rxjs';

@Component({
  selector: 'page-view-contact-pdf',
  templateUrl: 'view-contact-pdf.html',
  providers: [ContactFormService]
})
export class ViewContactPdfPage {
  public usersDetails : any;
  public contact_uid: any;
  public singleUserDetails: any;
  public unique_key: any;
  public user_data: any;
  public employment: any;
  public secondary_user_datas: any;
  public secondary_user_employment: any;
  public secondary_user_employment_datas: any;
  public realestates: any;
  public tentativerealestates: any;
  public total_current_balance: any;
  public total_mortgage_limit: any;
  public total_asset_value: any;
  public total_available_redraw: any;
  public total_repayments: any;
  public total_annual_repayments_limit: any;
  public total_gross_amount: any;
  public total_rent_annual: any;
  public total_lvr: any;
  public total_tentative_current_balance : any;
  public total_tentative_current_balance1 : any;
  public total_tentative_mortgage_limit : any;
  public total_tentative_mortgage_limit1 : any;
  public total_tentative_asset_value : any;
  public total_tentative_asset_value1 : any;
  public total_tentative_available_redraw : any;
  public total_tentative_available_redraw1 : any;
  public total_tentative_repayments : any;
  public total_tentative_repayments1 : any;
  public total_tentative_annual_repayments_limit : any;
  public total_tentative_annual_repayments_limit1 : any;
  public total_tentative_gross_amount : any;
  public total_tentative_gross_amount1 : any;
  public total_tentative_rent_annual : any;
  public total_tentative_rent_annual1 : any;
  public total_tentative_lvr : any;
  public total_tentative_lvr1 : any;
  public pdfMake: any;
  public contentDataURL: any;
  public pdfDoc: any;
  public t_document_id: any;
  public userRole: any;
  public assets: any;
  public liabilities: any;
  public incomes: any;
  public showHideTentativetable : any = false;
  public showHideTentativetableIcon : any = 'apps';
  public showHideRealtable : any = false;
  public showHideRealtableIcon : any = 'apps';

  public annual_repayments_limit1:any;
  public annual_repayments_limit2:any;
  public realestateSplits: any;
  public split_current_balance : any;
  public split_mortgage_limit : any;
  public split_available_redraw: any;
  public split_repayments : any;
  public split_interest_rate : any;
  public split_creditor : any;
  public split_interest_rate_term : any;
  public split_loan_type : any;
  public split_tentative_creditor : any;
  public split_tentative_interest_rate_term : any;
  public split_tentative_loan_type : any;
  public tentative_annual_repayments_limit1:any;
  public tentative_annual_repayments_limit2:any;
  public tentative_realestateSplits: any;
  public split_tentative_current_balance : any;
  public split_tentative_mortgage_limit : any;
  public split_tentative_repayments : any;
  public split_tentative_interest_rate : any;
  public primary_secondary_found: any;
  public grid: any;
  public gridHeight: any;
  public SDF_form_document_id: any;
  public secondary_applicant: any;
  public accessGrantedFromUserstatus: any;
  public realestates_load=false;
  public secondary_applicant_load =false;


  public showHideLeaderAddressRealestate: any;
  public showHideLeaderAssetValueRealestate: any;
  public showHideLeaderOwnershipTitleNameRealestate: any;
  public showHideLeaderRentAnnualRealestate: any;
  public showHideLeaderGrossAmountRealestate: any;
  public showHideLeaderCreditorRealestate: any;
  public showHideLeaderMortgageLimitRealestate: any;
  public showHideLeaderCurrentBalanceRealestate: any;
  public showHideLeaderIntrestRateRealestate: any;
  public showHideLeaderInterestRateTermRealestate: any;
  public showHideLeaderLoanTypeRealestate: any;
  public showHideLeaderRepaymentsRealestate: any;

  public showHideLeaderAddressTentaRealestate: any;
  public showHideLeaderAssetValueTentaRealestate: any;
  public showHideLeaderOwnershipTitleTentaRealestate: any;
  public showHideLeaderRentAnnualTentaRealestate: any;
  public showHideLeaderGrossAmountTentaRealestate: any;
  public showHideLeaderCreditorTentaRealestate: any;
  public showHideLeaderMortgageLimitTentaRealestate: any;
  public showHideLeaderCurrentBalanceTentaRealestate: any;
  public showHideLeaderIntrestRateTentaRealestate: any;
  public showHideLeaderInterestRateTermTentaRealestate: any;
  public showHideLeaderLoanTypeTentaRealestate: any;
  public showHideLeaderRepaymentsTentaRealestate: any;

  public realEstateTotalSplitMortgageLimit :any;
  public realEstateTotalSplitCurrentBalance:any;
  public realEstateTotalSplitAvailableRedraw:any; 
  public realEstateTotalSplitRepayments:any;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public http : Http,
    public db: AngularFirestore,
    public loadingProvider: LoadingProvider,
    private ContactFormService: ContactFormService,
  ) {
    this.incomes = [];
    this.assets = [];
    this.liabilities = [];

    this.realestates = '';
    this.tentativerealestates = '';

    this.secondary_user_datas = [];
    this.user_data = '';
    this.employment = '';
    let thiss = this;
    this.total_tentative_current_balance1 = [];
    this.total_tentative_mortgage_limit1 = [];
    this.total_tentative_asset_value1 = [];
    this.total_tentative_available_redraw1 = [];
    this.total_tentative_repayments1 = [];
    this.total_tentative_annual_repayments_limit1 = [];
    this.total_tentative_gross_amount1 = [];
    this.total_tentative_rent_annual1 = [];
    this.total_tentative_lvr1 = [];
    this.userRole = window.localStorage.getItem("userRole");

    if(this.userRole == 'broker' || this.userRole == 'super_admin' || this.userRole == 'loan_admin'){
      this.contact_uid = this.navParams.get("contact_uid");
      this.t_document_id = this.navParams.get("t_document_id");
      this.SDF_form_document_id = this.navParams.get("SDF_form_document_id");
    }else{
      this.contact_uid = location.search.split('id=')[1];
      this.t_document_id = location.search.split('&docId=')[1];
      if(this.t_document_id != undefined){
        this.contact_uid = this.contact_uid.split('&docId=')[0];
      }
    }

    // if(thiss.SDF_form_document_id != undefined){

    //   let SDF_form = firebase.firestore().collection("SDF_form").doc(thiss.SDF_form_document_id);
    //   SDF_form.get().then(function(SDF_form_doc) {
    //     if (SDF_form_doc.exists) {
    //       let sdf_data = SDF_form_doc.data();
    //       let main_uid = sdf_data.uid;
    //       let docRef1 = firebase.firestore().collection("users").doc(main_uid);
    //       docRef1.get().then(function(doc) {
    //         if (doc.exists) {
    //           thiss.user_data = doc.data();
    //           thiss.get_user_data(main_uid, thiss.SDF_form_document_id).subscribe((get_user_data)=>{
    //             if(get_user_data.length > 0){
    //               thiss.user_data = get_user_data[0];
    //               thiss.user_data.accessGrantedFromUser = get_user_data[0].accessGrantedFromUser;
    //               thiss.user_data.email = doc.data().email;
    //               thiss.user_data.mobile_phone = doc.data().mobile_phone;
    //               firebase.firestore().collection("employment").where("SDF_form", "==", thiss.SDF_form_document_id).where("uid", "==", main_uid).get()
    //               .then(function(querySnapshot2) {
    //                 querySnapshot2.forEach(function(empDoc) {
    //                   thiss.employment = empDoc.data();
    //                 });
    //               })
    //               thiss.get_second_user_data(thiss.SDF_form_document_id).subscribe((get_second_user_data)=>{
    //                 if(get_second_user_data.length > 0){
    //                   thiss.secondary_applicant = [];
    //                   Object.keys(get_second_user_data).forEach(function(key) {
    //                     var secondUser = firebase.firestore().collection("users").doc(get_second_user_data[key].uid);
    //                     secondUser.get().then(function(secdoc) {
    //                       if (secdoc.exists) {
    //                         firebase.firestore().collection("employment").where("SDF_form", "==", thiss.SDF_form_document_id).where("uid", "==", get_second_user_data[key].uid).get()
    //                         .then(function(querySnapshotEmp) {
    //                           querySnapshotEmp.forEach(function(empDoc1) {
    //                             thiss.secondary_applicant.push({'employment': empDoc1.data(), 'second_user_data': get_second_user_data[key], 'email': secdoc.data().email, 'mobile_phone': secdoc.data().mobile_phone});
    //                           })
    //                           if(querySnapshotEmp.empty){
    //                             thiss.secondary_applicant.push({'employment': [], 'second_user_data': get_second_user_data[key], 'email': secdoc.data().email, 'mobile_phone': secdoc.data().mobile_phone});
    //                           }
    //                         });
    //                       }
    //                     });
    //                   })
    //                 }
    //               });
    //             }
    //           });
    //           thiss.get_incomes(sdf_data.id).subscribe((get_incomes)=>{
    //             if(get_incomes.length > 0){
    //               thiss.incomes = get_incomes
    //               Object.keys(get_incomes).forEach(function(key) {
    //                 thiss.get_owner(get_incomes[key].SDF_form, get_incomes[key].uid).subscribe((get_owner)=>{
    //                   if(get_owner.length > 0){
    //                     thiss.incomes[key].firstname = get_owner[0].firstname;
    //                     thiss.incomes[key].lastname = get_owner[0].lastname;
    //                   }
    //                 });
    //               })
    //             }
    //           });
    //           thiss.get_assets(sdf_data.id).subscribe((get_assets)=>{
    //             if(get_assets.length > 0){
    //               thiss.assets = get_assets
    //               Object.keys(get_assets).forEach(function(key) {
    //                 thiss.get_owner(get_assets[key].SDF_form, get_assets[key].uid).subscribe((get_owner)=>{
    //                   if(get_owner.length > 0){
    //                     thiss.assets[key].firstname = get_owner[0].firstname;
    //                     thiss.assets[key].lastname = get_owner[0].lastname;
    //                   }
    //                 });
    //               })
    //             }
    //           });
    //           thiss.get_liabilities(sdf_data.id).subscribe((get_liabilities)=>{
    //             if(get_liabilities.length > 0){
    //               thiss.liabilities = get_liabilities
    //               Object.keys(get_liabilities).forEach(function(key) {
    //                 thiss.get_owner(get_liabilities[key].SDF_form, get_liabilities[key].uid).subscribe((get_owner)=>{
    //                   if(get_owner.length > 0){
    //                     thiss.liabilities[key].firstname = get_owner[0].firstname;
    //                     thiss.liabilities[key].lastname = get_owner[0].lastname;
    //                   }
    //                 });
    //               })
    //             }
    //           });
    //           thiss.get_realEstates(sdf_data.id).subscribe((get_realEstates)=>{
    //             if(get_realEstates.length > 0){
    //               thiss.total_current_balance = parseInt('0');
    //               thiss.total_mortgage_limit = parseInt('0');
    //               thiss.total_asset_value = parseInt('0');
    //               thiss.total_available_redraw = parseInt('0');
    //               thiss.total_repayments = parseInt('0');
    //               thiss.total_annual_repayments_limit = parseInt('0');
    //               thiss.total_gross_amount = parseInt('0');
    //               thiss.total_rent_annual = parseInt('0');
    //               thiss.total_lvr = parseInt('0');
    //               thiss.realestateSplits = [];
    //               let showHideLeaderCreditorRealestate = [];
    //               let showHideLeaderMortgageLimitRealestate = [];
    //               let showHideLeaderCurrentBalanceRealestate = [];
    //               let showHideLeaderIntrestRateRealestate = [];
    //               let showHideLeaderInterestRateTermRealestate = [];
    //               let showHideLeaderLoanTypeRealestate = [];
    //               let showHideLeaderRepaymentsRealestate = [];

    //               thiss.realestates = get_realEstates;
    //               get_realEstates.forEach(function (value, index) {
    //                 thiss.split_current_balance = parseInt('0');
    //                 thiss.split_mortgage_limit = parseInt('0');
    //                 thiss.split_available_redraw = parseInt('0');
    //                 thiss.split_repayments = parseInt('0');
    //                 thiss.annual_repayments_limit1 = parseInt('0');
    //                 thiss.annual_repayments_limit2 = parseInt('0');
    //                 thiss.split_interest_rate = parseFloat('0');
    //                 if(value.split.length > 0){
    //                   showHideLeaderCreditorRealestate = [];
    //                   showHideLeaderMortgageLimitRealestate = [];
    //                   showHideLeaderCurrentBalanceRealestate = [];
    //                   showHideLeaderIntrestRateRealestate = [];
    //                   showHideLeaderInterestRateTermRealestate = [];
    //                   showHideLeaderLoanTypeRealestate = [];
    //                   showHideLeaderRepaymentsRealestate = [];
    //                   value.split.forEach(function (value2, key2) {
    //                     showHideLeaderCreditorRealestate.push(0);
    //                     showHideLeaderMortgageLimitRealestate.push(0);
    //                     showHideLeaderCurrentBalanceRealestate.push(0);
    //                     showHideLeaderIntrestRateRealestate.push(0);
    //                     showHideLeaderInterestRateTermRealestate.push(0);
    //                     showHideLeaderLoanTypeRealestate.push(0);
    //                     showHideLeaderRepaymentsRealestate.push(0);
    //                     thiss.split_current_balance += parseInt(value2.current_balance.split("$").join("").split(",").join(""));
    //                     thiss.split_mortgage_limit += parseInt((value2.mortgage_limit == undefined) ? 0 : value2.mortgage_limit.split("$").join("").split(",").join(""));
    //                     thiss.split_available_redraw += parseInt((isNaN(value2.available_redraw)) ? value2.available_redraw.split("$").join("").split(",").join("") : value2.available_redraw);
    //                     thiss.split_repayments += parseInt(value2.repayments.split("$").join("").split(",").join(""));
    //                     thiss.split_interest_rate += parseFloat(value2.interest_rate);
    //                     thiss.split_creditor = value2.creditor;
    //                     thiss.split_loan_type = value2.loan_type;
    //                     thiss.split_interest_rate_term = value2.interest_rate_term;

    //                     let CB = parseInt(value2.current_balance.split("$").join("").split(",").join(""));
    //                     let IR = parseFloat(value2.interest_rate);

    //                     thiss.annual_repayments_limit1 += ((CB)*(IR/100));

    //                     thiss.realestates[index].split[key2].current_balance = parseInt(value2.current_balance.split("$").join("").split(",").join(""));
    //                     thiss.realestates[index].split[key2].mortgage_limit = parseInt((value2.mortgage_limit == undefined) ? 0 : value2.mortgage_limit.split("$").join("").split(",").join(""));
    //                     thiss.realestates[index].split[key2].available_redraw = parseInt((isNaN(value2.available_redraw)) ? value2.available_redraw.split("$").join("").split(",").join("") : value2.available_redraw);
    //                     thiss.realestates[index].split[key2].repayments = parseInt(value2.repayments.split("$").join("").split(",").join(""));
    //                   });

    //                   thiss.realestates[index].creditor = thiss.split_creditor;
    //                   thiss.realestates[index].interest_rate_term = thiss.split_interest_rate_term;
    //                   thiss.realestates[index].loan_type = thiss.split_loan_type;
    //                   thiss.realestates[index].mortgage_limit = thiss.split_mortgage_limit;
    //                   thiss.realestates[index].available_redraw = thiss.split_available_redraw;
    //                   thiss.realestates[index].current_balance = thiss.split_current_balance;
    //                   thiss.realestates[index].repayments = thiss.split_repayments;
    //                   thiss.realestates[index].interest_rate = thiss.split_interest_rate;
    //                   //thiss.realestates[index].available_redraw = thiss.split_mortgage_limit - thiss.split_current_balance;
    //                   thiss.realestates[index].lvr = ((thiss.split_current_balance/parseInt(value.asset_value))*100).toFixed(2);

    //                   thiss.total_current_balance += parseInt(thiss.split_current_balance);
    //                   thiss.total_mortgage_limit += parseInt(thiss.split_mortgage_limit);
    //                   thiss.total_asset_value += parseInt(value.asset_value);
    //                   thiss.total_available_redraw += parseInt(thiss.split_available_redraw);
    //                   //thiss.total_available_redraw += parseInt(thiss.split_mortgage_limit) - parseInt(thiss.split_current_balance);
    //                   thiss.total_repayments += parseInt(thiss.split_repayments);
    //                   thiss.total_gross_amount += parseInt(value.gross_amount);
    //                   thiss.total_rent_annual += parseInt(value.rent_annual);
    //                   thiss.realestates[index].lvr = ((parseInt(thiss.split_current_balance)/parseInt(value.asset_value))*100).toFixed(2);
    //                   thiss.annual_repayments_limit1 = (parseInt(thiss.split_current_balance)*(parseFloat(thiss.split_interest_rate)/100)).toFixed(2);
    //                   thiss.annual_repayments_limit2 = (parseInt(thiss.split_current_balance)*12).toFixed(2);
    //                   if(parseInt(thiss.annual_repayments_limit1) > parseInt(thiss.annual_repayments_limit2)){
    //                     thiss.total_annual_repayments_limit += parseInt(thiss.annual_repayments_limit1);
    //                     thiss.realestates[index].annual_repayments_limit = parseInt(thiss.annual_repayments_limit1);
    //                   }else{
    //                     thiss.total_annual_repayments_limit += parseInt(thiss.annual_repayments_limit2);
    //                     thiss.realestates[index].annual_repayments_limit = parseInt(thiss.annual_repayments_limit2);
    //                   }
    //                   thiss.total_lvr = ((thiss.total_current_balance/thiss.total_asset_value)*100).toFixed(2);
    //                 }
    //               });
    //             }
    //           });

    //           if(thiss.user_data.how_many_children > 0){}else{
    //             thiss.user_data.how_many_children = 0;
    //           }

    //         }
    //       });
    //     }

    //   }).catch(function(error) {
    //     console.log("Error getting document:", error);
    //   });

    //   thiss.getAllTentativeRealEstates().subscribe((tdata)=>{
    //     if(tdata.length > 0){
    //       thiss.tentativerealestates = [];
    //       thiss.showHideTentativetable = [];
    //       let group_id = parseInt('0');

    //       let showHideLeaderAddressTentaRealestate = [];
    //       let showHideLeaderAssetValueTentaRealestate = [];
    //       let showHideLeaderOwnershipTitleTentaRealestate = [];
    //       let showHideLeaderCreditorTentaRealestate = [];
    //       let showHideLeaderMortgageLimitTentaRealestate = [];
    //       let showHideLeaderCurrentBalanceTentaRealestate = [];
    //       let showHideLeaderIntrestRateTentaRealestate = [];
    //       let showHideLeaderInterestRateTermTentaRealestate = [];
    //       let showHideLeaderLoanTypeTentaRealestate = [];
    //       let showHideLeaderRepaymentsTentaRealestate = [];
    //       let showHideLeaderGrossAmountTentaRealestate = [];

    //       tdata.forEach(function (value, key) {

    //         if(value.group_id != group_id){

    //           showHideLeaderAddressTentaRealestate = [];
    //           showHideLeaderAssetValueTentaRealestate = [];
    //           showHideLeaderOwnershipTitleTentaRealestate = [];
    //           showHideLeaderCreditorTentaRealestate = [];
    //           showHideLeaderMortgageLimitTentaRealestate = [];
    //           showHideLeaderCurrentBalanceTentaRealestate = [];
    //           showHideLeaderIntrestRateTentaRealestate = [];
    //           showHideLeaderInterestRateTermTentaRealestate = [];
    //           showHideLeaderLoanTypeTentaRealestate = [];
    //           showHideLeaderRepaymentsTentaRealestate = [];
    //           showHideLeaderGrossAmountTentaRealestate = [];

    //           let totalECB = parseInt('0');
    //           let totalCB = parseInt('0');
    //           let totalML = parseInt('0');
    //           let totalAA = parseInt('0');
    //           let totalMR = parseInt('0');
    //           let totalARL = parseInt('0');
    //           let totalRIW = parseInt('0');
    //           let totalRA = parseInt('0');
    //           let totalLVR = '';

    //           var groupData = thiss.getDimensionsByFilter(value.group_id, tdata);

    //           groupData.forEach(function (value1, key1) {

    //             let showHideLeaderCreditorTentaRealestateSplit = [];
    //             let showHideLeaderMortgageLimitTentaRealestateSplit = [];
    //             let showHideLeaderCurrentBalanceTentaRealestateSplit = [];
    //             let showHideLeaderIntrestRateTentaRealestateSplit = [];
    //             let showHideLeaderInterestRateTermTentaRealestateSplit = [];
    //             let showHideLeaderLoanTypeTentaRealestateSplit = [];
    //             let showHideLeaderRepaymentsTentaRealestateSplit = [];

    //             let split_tentative_creditor = '';
    //             let split_tentative_interest_rate_term = '';
    //             let split_tentative_loan_type = '';
    //             let split_tentative_mortgage_limit = parseInt('0');
    //             let split_tentative_current_balance = parseInt('0');
    //             let split_tentative_available_redraw = parseInt('0');
    //             let split_tentative_repayments = parseInt('0');
    //             let split_tentative_interest_rate = parseInt('0');
    //             let annual_repayments_limit1 = parseInt('0');
    //             if(value1.split.length > 0){
    //               value1.split.forEach(function (value2, key2) {

    //                 showHideLeaderCreditorTentaRealestateSplit.push(0);
    //                 showHideLeaderMortgageLimitTentaRealestateSplit.push(0);
    //                 showHideLeaderCurrentBalanceTentaRealestateSplit.push(0);
    //                 showHideLeaderIntrestRateTentaRealestateSplit.push(0);
    //                 showHideLeaderInterestRateTermTentaRealestateSplit.push(0);
    //                 showHideLeaderLoanTypeTentaRealestateSplit.push(0);
    //                 showHideLeaderRepaymentsTentaRealestateSplit.push(0);

    //                 split_tentative_current_balance += parseInt(value2.current_balance.split("$").join("").split(",").join(""));
    //                 split_tentative_mortgage_limit += parseInt((value2.mortgage_limit == undefined) ? 0 : value2.mortgage_limit.split("$").join("").split(",").join(""));
    //                 split_tentative_available_redraw += parseInt((isNaN(value2.available_redraw)) ? value2.available_redraw.split("$").join("").split(",").join("") : value2.available_redraw);
    //                 split_tentative_repayments += parseInt(value2.repayments.split("$").join("").split(",").join(""));
    //                 split_tentative_interest_rate += parseFloat(value2.interest_rate);
    //                 split_tentative_creditor = value2.creditor;
    //                 split_tentative_loan_type = value2.loan_type;
    //                 split_tentative_interest_rate_term = value2.interest_rate_term;

    //                 let CB = parseInt(value2.current_balance.split("$").join("").split(",").join(""));
    //                 let IR = parseFloat(value2.interest_rate);

    //                 annual_repayments_limit1 += ((CB)*(IR/100));

    //                 groupData[key1].split[key2].current_balance = parseInt(value2.current_balance.split("$").join("").split(",").join(""));
    //                 groupData[key1].split[key2].mortgage_limit = parseInt((value2.mortgage_limit == undefined) ? 0 : value2.mortgage_limit.split("$").join("").split(",").join(""));
    //                 groupData[key1].split[key2].available_redraw = parseInt((isNaN(value2.available_redraw)) ? value2.available_redraw.split("$").join("").split(",").join("") : value2.available_redraw);
    //                 groupData[key1].split[key2].repayments = parseInt(value2.repayments.split("$").join("").split(",").join(""));
    //               });
    //             }

    //             groupData[key1].creditor = split_tentative_creditor;
    //             groupData[key1].interest_rate_term = split_tentative_interest_rate_term;
    //             groupData[key1].loan_type = split_tentative_loan_type;
    //             groupData[key1].mortgage_limit = split_tentative_mortgage_limit;
    //             groupData[key1].current_balance = split_tentative_current_balance;
    //             groupData[key1].available_redraw = split_tentative_available_redraw;
    //             groupData[key1].repayments = split_tentative_repayments;
    //             groupData[key1].interest_rate = split_tentative_interest_rate;
    //             groupData[key1].available_redraw = split_tentative_mortgage_limit - split_tentative_current_balance;
    //             groupData[key1].lvr = ((split_tentative_current_balance/parseInt(value1.asset_value))*100).toFixed(2);


    //             totalECB += parseInt(value1.asset_value);
    //             totalCB += split_tentative_current_balance;
    //             totalML += split_tentative_mortgage_limit;
    //             totalAA += split_tentative_available_redraw;
    //             totalMR += split_tentative_repayments;
    //             totalRIW += parseInt(value1.gross_amount);
    //             totalRA += parseInt(value1.rent_annual);
    //             totalLVR = ((totalCB/totalECB)*100).toFixed(2);

    //             let annual_repayments_limit2 = (totalMR*12).toFixed(2);
    //             if(annual_repayments_limit1 > parseInt(annual_repayments_limit2)){
    //               groupData[key1].annual_repayments_limit = annual_repayments_limit1;
    //               totalARL += annual_repayments_limit1;
    //             }else{
    //               groupData[key1].annual_repayments_limit = parseInt(annual_repayments_limit2);
    //               totalARL += parseInt(annual_repayments_limit2);
    //             }

    //             showHideLeaderAddressTentaRealestate.push(0);
    //             showHideLeaderAssetValueTentaRealestate.push(0);
    //             showHideLeaderOwnershipTitleTentaRealestate.push(0);
    //             showHideLeaderGrossAmountTentaRealestate.push(0);
    //             showHideLeaderCreditorTentaRealestate.push(showHideLeaderCreditorTentaRealestateSplit);
    //             showHideLeaderMortgageLimitTentaRealestate.push(showHideLeaderMortgageLimitTentaRealestateSplit);
    //             showHideLeaderCurrentBalanceTentaRealestate.push(showHideLeaderCurrentBalanceTentaRealestateSplit);
    //             showHideLeaderIntrestRateTentaRealestate.push(showHideLeaderIntrestRateTentaRealestateSplit);
    //             showHideLeaderInterestRateTermTentaRealestate.push(showHideLeaderInterestRateTermTentaRealestateSplit);
    //             showHideLeaderLoanTypeTentaRealestate.push(showHideLeaderLoanTypeTentaRealestateSplit);
    //             showHideLeaderRepaymentsTentaRealestate.push(showHideLeaderRepaymentsTentaRealestateSplit);


    //           });
    //           let splitData = [];
    //           splitData.push({});
    //           groupData.push({'current_balance' : totalCB, 'mortgage_limit' : totalML, 'asset_value' : totalECB, 'available_redraw' : totalAA, 'repayments' : totalMR, 'gross_amount' : totalRIW, 'rent_annual' : totalRA, 'lvr' : totalLVR, 'annual_repayments_limit' : totalARL.toFixed(2), 'split' : splitData});

    //           thiss.tentativerealestates.push(groupData);
    //         }
    //         group_id = value.group_id;
    //       });
    //     }
    //   });
    // }

    if (thiss.SDF_form_document_id != undefined) {
      this.ContactFormService.getspecificApplicationsById(thiss.SDF_form_document_id).then((data: any) => {
        console.log('adf form details:Test', data);
        var get_user_data = data;
        thiss.user_data = get_user_data;
        thiss.user_data.accessGrantedFromUser = (data.accessGrantedFromUser == undefined) ? 0 : data.accessGrantedFromUser;
        thiss.accessGrantedFromUserstatus = thiss.user_data.accessGrantedFromUser;
        // if (uid == thiss.user_data.uid) {
        //   thiss.userAccessEdit = (data.allowCustoeditPermission == undefined) ? 0 : data[0].allowCustoeditPermission;
        //   thiss.userAccessView = (data.allowCustoViewOnlyPermission == undefined) ? 0 : data[0].allowCustoViewOnlyPermission;
        // }

        if (data.realestates !== undefined) {
          thiss.realestates = data.realestate;
          thiss.realestates_load=true;
        }

        if (data.realestate !== undefined ||data.realestate.length==0) {
         

          if(data.realestate.length > 0){
            thiss.total_current_balance = parseInt('0');
            thiss.total_mortgage_limit = parseInt('0');
            thiss.total_asset_value = parseInt('0');
            thiss.total_available_redraw = parseInt('0');
            thiss.total_repayments = parseInt('0');
            thiss.total_annual_repayments_limit = parseInt('0');
            thiss.total_gross_amount = parseInt('0');
            thiss.total_rent_annual = parseInt('0');
            thiss.total_lvr = parseInt('0');
            thiss.realestateSplits = [];
            thiss.showHideLeaderAddressRealestate = [];
            thiss.showHideLeaderAssetValueRealestate = [];
            thiss.showHideLeaderOwnershipTitleNameRealestate = [];
            thiss.showHideLeaderRentAnnualRealestate = [];
            thiss.showHideLeaderGrossAmountRealestate = [];

            thiss.showHideLeaderCreditorRealestate = [];
            thiss.showHideLeaderMortgageLimitRealestate = [];
            thiss.showHideLeaderCurrentBalanceRealestate = [];
            thiss.showHideLeaderIntrestRateRealestate = [];
            thiss.showHideLeaderInterestRateTermRealestate = [];
            thiss.showHideLeaderLoanTypeRealestate = [];
            thiss.showHideLeaderRepaymentsRealestate = [];

            let showHideLeaderCreditorRealestate = [];
            let showHideLeaderMortgageLimitRealestate = [];
            let showHideLeaderCurrentBalanceRealestate = [];
            let showHideLeaderIntrestRateRealestate = [];
            let showHideLeaderInterestRateTermRealestate = [];
            let showHideLeaderLoanTypeRealestate = [];
            let showHideLeaderRepaymentsRealestate = [];
            let realestate = [];

            data.realestate.forEach(function (value, index) {
              if(!value.itemRowsMortgageSplits) {
                
                let splits = [];

                if(value.split == 0) {
                  value.itemRowsMortgageSplits = splits;
                }
                else {

                  value.split.forEach(splititem => {


                    // if(typeof splititem.current_balance == "string") {

                    //   let current_balancet_arr = splititem.current_balance.split("$");
                    //   let current_balancet_arr_curen =  current_balancet_arr[1].split(",");
  
                    //       var current_balancet_arr_curencuren = "";
                    //       for ( i = 0; i < current_balancet_arr_curen.length; i++) {
                    //         current_balancet_arr_curencuren += current_balancet_arr_curen[i]; 
                    //       }
  
                    //       splititem.current_balance = parseInt(current_balancet_arr_curencuren)
                      
                    // }
                    // if(typeof splititem.repayments == "string") {

                    //   let repayments_arr = splititem.repayments.split("$");
                    //   let repayments_arr_curen =  repayments_arr[1].split(",");
  
                    //       var repayments_arr_curencuren = "";
                    //       for ( i = 0; i < repayments_arr_curen.length; i++) {
                    //         repayments_arr_curencuren += repayments_arr_curen[i]; 
                    //       }
  
                    //       splititem.repayments = parseInt(repayments_arr_curencuren)
                      
                    // }
                    // if(typeof splititem.mortgage_limit == "string") {

                    //   let mortgage_limit_arr = splititem.mortgage_limit.split("$");
                    //   let mortgage_limit_arr_curen =  mortgage_limit_arr[1].split(",");
  
                    //       var mortgage_limit_arr_curencuren = "";
                    //       for ( i = 0; i < mortgage_limit_arr_curen.length; i++) {
                    //         mortgage_limit_arr_curencuren += mortgage_limit_arr_curen[i]; 
                    //       }
  
                    //       splititem.mortgage_limit = parseInt(mortgage_limit_arr_curencuren)
                      
                    // }

                    // if(typeof splititem.current_balance == "string") {

                    //   let balance_arr = splititem.current_balance.split("$");
                    //   splititem.current_balance =  parseInt(balance_arr[1]);
                      
                    // }

                    // if(typeof splititem.mortgage_limit == "string") {
                    //   let mortgage_arr = splititem.mortgage_limit.split("$");
                    //   splititem.mortgage_limit =  parseInt(mortgage_arr[1]);

                    // }

                    // if(typeof splititem.repayments == "string") {
                    //   let repayments_arr = splititem.repayments.split("$");
                    //   splititem.repayments =  parseInt(repayments_arr[1]);

                    // }
                
                    splits.push(splititem);
                    
                  });
  
                  value.itemRowsMortgageSplits = splits;
                }


              }
              value.created_date = data.created_date
              realestate.push(value);
            })
            console.log(realestate);
            
            // thiss.realestates = data.realestate;
            thiss.realestates = realestate;
            realestate.forEach(function (value, index) {
             
              thiss.showHideLeaderAddressRealestate.push(0);
              thiss.showHideLeaderAssetValueRealestate.push(0);
              thiss.showHideLeaderOwnershipTitleNameRealestate.push(0);
              thiss.showHideLeaderRentAnnualRealestate.push(0);
              thiss.showHideLeaderGrossAmountRealestate.push(0);
              
              thiss.split_current_balance = 0;
              thiss.split_mortgage_limit = parseFloat('0');
              thiss.split_available_redraw = parseFloat('0');
              thiss.split_repayments = parseFloat('0');
              thiss.annual_repayments_limit1 = parseInt('0');
              thiss.annual_repayments_limit2 = parseInt('0');
              thiss.split_interest_rate = parseFloat('0');
  
              if(value.itemRowsMortgageSplits.length > 0){
             
                showHideLeaderCreditorRealestate = [];
                showHideLeaderMortgageLimitRealestate = [];
                showHideLeaderCurrentBalanceRealestate = [];
                showHideLeaderIntrestRateRealestate = [];
                showHideLeaderInterestRateTermRealestate = [];
                showHideLeaderLoanTypeRealestate = [];
                showHideLeaderRepaymentsRealestate = [];
                 value.itemRowsMortgageSplits.forEach(function (value2, key2) {
                  
                 
                  showHideLeaderCreditorRealestate.push(0);
                  showHideLeaderMortgageLimitRealestate.push(0);
                  showHideLeaderCurrentBalanceRealestate.push(0);
                  showHideLeaderIntrestRateRealestate.push(0);
                  showHideLeaderInterestRateTermRealestate.push(0);
                  showHideLeaderLoanTypeRealestate.push(0);
                  showHideLeaderRepaymentsRealestate.push(0);
                 
                  // if(typeof value2.current_balance == "string") {

                  //   let current_arr = value2.current_balance.split("$");
                  //   let split_curen =  current_arr[1].split(",");

                  //       if(split_curen.length > 0) {
                  //         var finalcuren = "";
                  //           for ( i = 0; i < split_curen.length; i++) {
                  //             finalcuren += split_curen[i]; 
                  //           }

                  //         value2.current_balance = parseInt(finalcuren)
                  //       }
                  //       else {
                  //         value2.current_balance =  parseInt(current_arr[1]);
                  //       }
                        
                    
                  // }

                   if(typeof value2.current_balance == "string") {
                  var current_balance= value2.current_balance.replaceAll(/[`~!@#$%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/]/gi, '');
                  //var current_balance = value2.current_balance.replace("$", "");
                  console.log(current_balance);
                  thiss.split_current_balance = (parseFloat(thiss.split_current_balance)+parseFloat(current_balance)).toFixed(2);
                  
                  thiss.split_current_balance = thiss.split_current_balance.replace(/^0+/, '');
                 }
                 if(typeof value2.current_balance == "object") {
                   //var current_balance = 0;
                   value2.current_balance = "$ 0.00";
                    current_balance=0.00;
                    thiss.split_current_balance = (parseFloat(thiss.split_current_balance)+parseFloat(current_balance)).toFixed(2);
                 }
                 if(typeof value2.current_balance == "number") {
                  //var current_balance = 0;
                  //value2.current_balance = "$ 0.00";
                   current_balance=value2.current_balance;
                   thiss.split_current_balance = (parseFloat(thiss.split_current_balance)+parseFloat(current_balance)).toFixed(2);
                   let new_current_balance = parseFloat(current_balance).toFixed(2);
                   value2.current_balance = "$ "+thiss.formatMoney(new_current_balance);
                }
                 //number

                 console.log()
                console.log(typeof value2.current_balance);

                  

                  // if(typeof value2.mortgage_limit == "string") {

                  //   let mortgage_arr = value2.mortgage_limit.split("$");
                  //   let mortgage_curen =  mortgage_arr[1].split(",");

                  //     if(mortgage_curen.length > 0) {
                  //       var finalmortgage = "";
                  //       for ( i = 0; i < mortgage_curen.length; i++) {
                  //         finalmortgage += mortgage_curen[i]; 
                  //       }

                  //       value2.mortgage_limit = parseInt(finalmortgage)
                  //     }
                  //     else {
                  //       value2.mortgage_limit = mortgage_arr[1];
                  //     }
                        
                    
                  // }

                  if(typeof value2.mortgage_limit == "string") {
                    var mortgage_limit= value2.mortgage_limit.replaceAll(/[`~!@#$%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/]/gi, '');
                    //var mortgage_limit = value2.mortgage_limit.replace("$", "");
                    thiss.split_mortgage_limit = (parseFloat(thiss.split_mortgage_limit)+parseFloat(mortgage_limit)).toFixed(2);
                  
                    thiss.split_mortgage_limit = thiss.split_mortgage_limit.replace(/^0+/, '');

                   }
                   if(typeof value2.mortgage_limit == "object") {
                    //var current_balance = 0;
                    value2.mortgage_limit = "$ 0.00";
                    mortgage_limit=0.00;
                    thiss.split_mortgage_limit = (parseFloat(thiss.split_mortgage_limit)+parseFloat(mortgage_limit)).toFixed(2);
                  }
                   
                  if(typeof value2.mortgage_limit == "number") {
                    //var current_balance = 0;
                    //value2.current_balance = "$ 0.00";
                      mortgage_limit=value2.mortgage_limit;
                     thiss.split_mortgage_limit = (parseFloat(thiss.split_mortgage_limit)+parseFloat(mortgage_limit)).toFixed(2);
                     let new_mortage_limit = parseFloat(mortgage_limit).toFixed(2);
                     value2.mortgage_limit = "$ "+thiss.formatMoney(new_mortage_limit);
                  }
                  // thiss.split_mortgage_limit += parseFloat((mortgage_limit == undefined) ? 0 : mortgage_limit).toFixed(2);
                  // thiss.split_mortgage_limit = thiss.split_mortgage_limit.replace(/^0+/, '');
                  // if(typeof value2.available_redraw == "string") {

                  //   let redraw_arr = value2.available_redraw.split("$");
                  //   let redraw_curen =  redraw_arr[1].split(",");

                  //     if(redraw_curen.length > 0) {
                  //       var finalredraw = "";
                  //       for ( i = 0; i < redraw_curen.length; i++) {
                  //         finalredraw += redraw_curen[i]; 
                  //       }

                  //       value2.available_redraw = parseInt(finalredraw)
                  //     }
                  //     else {
                  //       value2.available_redraw = redraw_arr[1];
                  //     }
                        
                    
                  // }
                  if(typeof value2.available_redraw == "string") {
                    var available_redraw= value2.available_redraw.replaceAll(/[`~!@#$%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/]/gi, '');
                    //var available_redraw = value2.available_redraw.replace(" $", "");
                    thiss.split_available_redraw = (parseFloat(thiss.split_available_redraw)+parseFloat(available_redraw)).toFixed(2);
                  
                    thiss.split_available_redraw = thiss.split_available_redraw.replace(/^0+/, '');

                   }
                   if(typeof value2.available_redraw == "object") {
                    //var current_balance = 0;
                    value2.available_redraw = "$ 0.00";
                    available_redraw=0.00;
                    thiss.split_available_redraw = (parseFloat(thiss.split_available_redraw)+parseFloat(available_redraw)).toFixed(2);
                  }
                  if(typeof value2.available_redraw == "number") {
                    //var current_balance = 0;
                    //value2.current_balance = "$ 0.00";
                    available_redraw=value2.available_redraw;
                     thiss.split_available_redraw = (parseFloat(thiss.split_available_redraw)+parseFloat(available_redraw)).toFixed(2);
                     let newavailable_redraw = parseFloat(available_redraw).toFixed(2);
                     value2.available_redraw = "$ "+thiss.formatMoney(newavailable_redraw);
                  }
                  // thiss.split_available_redraw += parseFloat((isNaN(available_redraw)) ? available_redraw : available_redraw).toFixed(2);
                  // thiss.split_available_redraw = thiss.split_available_redraw.replace(/^0+/, '');
                   //console.log(thiss.split_available_redraw);
                  // if(typeof value2.repayments == "string") {

                  //   let repayments_arr = value2.repayments.split("$");
                  //   let repayments_curen =  repayments_arr[1].split(",");

                  //     if(repayments_curen.length > 0) {
                  //       var finalrepayments = "";
                  //       for ( i = 0; i < repayments_curen.length; i++) {
                  //         finalrepayments += repayments_curen[i]; 
                  //       }

                  //       value2.repayments = parseInt(finalrepayments)
                  //     }
                  //     else {
                  //       value2.repayments = repayments_arr[1];
                  //     }
                        
                    
                  // }
                  if(typeof value2.repayments == "string") {
                    var repayments= value2.repayments.replaceAll(/[`~!@#$%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/]/gi, '');
                    //var repayments = value2.repayments.replace("$", "");
                    //value2.repayments=parseFloat(repayments);
                    thiss.split_repayments = (parseFloat(thiss.split_repayments)+parseFloat(repayments)).toFixed(2);
                  
                    thiss.split_repayments = thiss.split_repayments.replace(/^0+/, '');
                    //console.logthis.formatMoney(value2.repayments);
                   }
                   if(typeof value2.repayments == "object") {
                    //var current_balance = 0;
                    value2.repayments = "$ 0.00";
                    repayments=0.00;
                    thiss.split_repayments = (parseFloat(thiss.split_repayments)+parseFloat(repayments)).toFixed(2);
                  }
                  if(typeof value2.repayments == "number") {
                    //var current_balance = 0;
                    //value2.current_balance = "$ 0.00";
                    repayments=value2.repayments;
                     thiss.split_repayments = (parseFloat(thiss.split_repayments)+parseFloat(repayments)).toFixed(2);
                     let newrepayments = parseFloat(repayments).toFixed(2);
                     value2.repayments = "$ "+thiss.formatMoney(newrepayments);
                  }
                  if(typeof value2.interest_rate == "object") {
                    //var current_balance = 0;
                    value2.interest_rate = "$ 0.00";
                  }

                   console.log(value2.repayments);
                  // thiss.split_repayments += parseFloat(repayments);
                  thiss.split_interest_rate += parseFloat(value2.interest_rate);
                  thiss.split_creditor = value2.creditor;
                  thiss.split_loan_type = value2.loan_type;
                  thiss.split_interest_rate_term = value2.interest_rate_term;

                  let CB = parseInt(current_balance);
                  let IR = parseFloat(value2.interest_rate);

                  thiss.annual_repayments_limit1 += ((CB)*(IR/100));

                  //thiss.realestates[index].itemRowsMortgageSplits[key2].current_balance = parseFloat(current_balance).toFixed(2);
                  thiss.realestates[index].itemRowsMortgageSplits[key2].mortgage_limit = parseFloat((mortgage_limit == undefined) ? 0 : mortgage_limit).toFixed(2);
                  // thiss.realestates[index].itemRowsMortgageSplits[key2].available_redraw = parseFloat((isNaN(available_redraw)) ? available_redraw : available_redraw).toFixed(2);
                  // thiss.realestates[index].itemRowsMortgageSplits[key2].repayments = parseFloat(repayments).toFixed(2);
                 });

                 console.log('working');
                 
                thiss.realestates[index].creditor = thiss.split_creditor;
                thiss.realestates[index].interest_rate_term = thiss.split_interest_rate_term;
                thiss.realestates[index].loan_type = thiss.split_loan_type;
                thiss.realestates[index].mortgage_limit = thiss.split_mortgage_limit;
                thiss.realestates[index].available_redraw = thiss.split_available_redraw;
                thiss.realestates[index].current_balance = thiss.split_current_balance;
                thiss.realestates[index].repayments = thiss.split_repayments;
                thiss.realestates[index].interest_rate = thiss.split_interest_rate;


                // if(typeof value.asset_value == "string") {

                //   let asset_arr = value.asset_value.split("$");
                //   let asset_curen =  asset_arr[1].split(",");

                //       if( asset_curen.length > 0) {
                //         var finalasset = "";
                //         for ( i = 0; i < asset_curen.length; i++) {
                //           finalasset += asset_curen[i]; 
                //         }
  
                //         value.asset_value = parseInt(finalasset)
                //       }
                //       else {
                //         value.asset_value = asset_arr[1];
                //       }
                      
                  
                // }
                
                 if(typeof value.asset_value == "string") {
                  var asset_value= value.asset_value.replaceAll(/[`~!@#$%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/]/gi, '');
                  asset_value = parseFloat(asset_value).toFixed(2);
                  value.asset_value = '$ '+thiss.formatMoney(asset_value);
                  //var asset_value = value.asset_value.replace("$", "");
                  //value.asset_value=asset_value;
                 }
                 else if(typeof value.asset_value == "number") {
                   asset_value = parseFloat(value.asset_value).toFixed(2);
                  value.asset_value = '$ '+thiss.formatMoney(asset_value);
                }
                 
                //var asset_value = value.asset_value;

                thiss.realestates[index].lvr = ((thiss.split_current_balance/asset_value)*100).toFixed(2);

                thiss.total_current_balance += parseFloat(thiss.split_current_balance).toFixed(2);
                thiss.total_current_balance = thiss.total_current_balance.replace(/^0+/, '');

                thiss.total_mortgage_limit += parseFloat(thiss.split_mortgage_limit).toFixed(2);
                thiss.total_mortgage_limit = thiss.total_mortgage_limit.replace(/^0+/, '');

                thiss.total_asset_value += parseFloat(asset_value).toFixed(2);
                thiss.total_asset_value = thiss.total_asset_value.replace(/^0+/, '');
                
                thiss.total_available_redraw += parseFloat(thiss.split_available_redraw).toFixed(2);
                thiss.total_available_redraw = thiss.total_available_redraw.replace(/^0+/, '');
               
                thiss.total_repayments += parseFloat(thiss.split_repayments).toFixed(2);
                thiss.total_repayments = thiss.total_repayments.replace(/^0+/, '');

                // if(typeof value.gross_amount == "string") {

                //   let gross_arr = value.gross_amount.split("$");
                //   let gross_arr_curen =  gross_arr[1].split(",");

                //      if(gross_arr_curen.length > 0) {
                //         var finalgross_arr_curen = "";
                //         for ( i = 0; i < gross_arr_curen.length; i++) {
                //           finalgross_arr_curen += gross_arr_curen[i]; 
                //         }

                //         value.gross_amount = parseInt(finalgross_arr_curen)
                //      }
                //      else {
                //       value.gross_amount = gross_arr[1];
                //      }
                      
                  
                // }


                if(typeof value.gross_amount == "string") {
                  var gross_amount= value.gross_amount.replaceAll(/[`~!@#$%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/]/gi, '');
                  gross_amount = parseFloat(gross_amount).toFixed(2);
                  value.gross_amount = '$ '+thiss.formatMoney(gross_amount);
                  //var gross_amount = value.gross_amount.replace("$", "");
                  //gross_amount=gross_amount;
                }
                else if(typeof value.gross_amount == "number") {
                  gross_amount = parseFloat(value.gross_amount).toFixed(2);
                 value.gross_amount = '$ '+thiss.formatMoney(gross_amount);
               }
                // else {
                //   var gross_amount = value.gross_amount;
                //   value.gross_amount = '$ '+gross_amount;
                // }
                //var gross_amount = value.gross_amount;
                
                value.rent_annual = parseInt(gross_amount)*52;

                thiss.total_gross_amount += parseInt(gross_amount);
                thiss.total_rent_annual += parseInt(gross_amount)*52;
               
                thiss.realestates[index].lvr = ((parseInt(thiss.split_current_balance)/asset_value)*100).toFixed(2);
                thiss.annual_repayments_limit1 = (parseInt(thiss.split_current_balance)*(parseFloat(thiss.split_interest_rate)/100)).toFixed(2);
                thiss.annual_repayments_limit2 = (parseInt(thiss.split_current_balance)*12).toFixed(2);
                if(parseInt(thiss.annual_repayments_limit1) > parseInt(thiss.annual_repayments_limit2)){
                  thiss.total_annual_repayments_limit += parseInt(thiss.annual_repayments_limit1);
                  thiss.realestates[index].annual_repayments_limit = parseInt(thiss.annual_repayments_limit1);
                }else{
                  thiss.total_annual_repayments_limit += parseInt(thiss.annual_repayments_limit2);
                  thiss.realestates[index].annual_repayments_limit = parseInt(thiss.annual_repayments_limit2);
                }
                thiss.total_lvr = ((thiss.total_current_balance/thiss.total_asset_value)*100).toFixed(2);
              }
              thiss.showHideLeaderCreditorRealestate.push(showHideLeaderCreditorRealestate);
              thiss.showHideLeaderMortgageLimitRealestate.push(showHideLeaderMortgageLimitRealestate);
              thiss.showHideLeaderCurrentBalanceRealestate.push(showHideLeaderCurrentBalanceRealestate);
              thiss.showHideLeaderIntrestRateRealestate.push(showHideLeaderIntrestRateRealestate);
              thiss.showHideLeaderInterestRateTermRealestate.push(showHideLeaderInterestRateTermRealestate);
              thiss.showHideLeaderLoanTypeRealestate.push(showHideLeaderLoanTypeRealestate);
              thiss.showHideLeaderRepaymentsRealestate.push(showHideLeaderRepaymentsRealestate);
             });

             console.log(data.realestate);
             debugger;
          }

        }


        if (data.contacts !== undefined) {
          data.contacts.forEach(contactElement => {
            contactElement.contact_details.employment_details.incomes.forEach(incomeElement => {
              thiss.incomes.push(incomeElement);
            });
          });
          // thiss.incomes = data.contacts[0].contact_details.employment_details.incomes;
        }

        if (data.assets !== undefined) {
          console.log('assets',data.assets)
          thiss.assets = data.assets;
        }

        if (data.liabilities !== undefined) {
          console.log('liabilities',data.liabilities)
          thiss.liabilities = data.liabilities;
        }


        for (var i = 0; i < data.contacts.length; i++) {
          if(data.contacts[i].type!=undefined){
            if (data.contacts[i].type == 'primary') {
              console.log('primary', data.contacts[i]);
              thiss.user_data.email = data.contacts[i].user_data.email;
              thiss.user_data.mobile_phone = data.contacts[i].user_data.mobile_phone;
              thiss.user_data.firstname = data.contacts[i].user_data.firstname;
              thiss.user_data.middlename = data.contacts[i].user_data.middlename;
              thiss.user_data.lastname = data.contacts[i].user_data.lastname;
              thiss.user_data.date_of_birth = data.contacts[i].user_data.date_of_birth;
              //thiss.user_data.housing_situation = data.contacts[i].contact_details.address[0].housing_situation;
              thiss.user_data.poboxlabel = data.contacts[i].contact_details.address[0].poboxlabel;
              thiss.user_data.floor_number = data.contacts[i].contact_details.address[0].floor_number;
              thiss.user_data.unit_number = data.contacts[i].contact_details.address[0].unit_number;
              thiss.user_data.building_name = data.contacts[i].contact_details.address[0].building_name;
              thiss.user_data.street_number = data.contacts[i].contact_details.address[0].street_number;
              thiss.user_data.street_name = data.contacts[i].contact_details.address[0].street_name;
              thiss.user_data.city = data.contacts[i].contact_details.address[0].city;
              thiss.user_data.state = data.contacts[i].contact_details.address[0].state;
              thiss.user_data.country = data.contacts[i].contact_details.address[0].country;
              thiss.user_data.postcode = data.contacts[i].contact_details.address[0].postcode;
              thiss.user_data.gender = data.contacts[i].contact_details.dependent.gender;
              thiss.user_data.current_marital_status = data.contacts[i].contact_details.dependent.current_marital_status;
              thiss.user_data.how_many_children = data.contacts[i].contact_details.dependent.how_many_children;
              if (data.contacts[i].contact_details.dependent.how_many_children >= 1) {
                thiss.user_data.first_child_age = data.contacts[i].contact_details.dependent.children_age[0].age;
              }
              if (data.contacts[i].contact_details.dependent.how_many_children >= 2) {
                thiss.user_data.second_child_age = data.contacts[i].contact_details.dependent.children_age[1].age;
              }
              if (data.contacts[i].contact_details.dependent.how_many_children >= 3) {
                thiss.user_data.third_child_age = data.contacts[i].contact_details.dependent.children_age[2].age;
              }
              if (data.contacts[i].contact_details.dependent.how_many_children >= 4) {
                thiss.user_data.fourth_child_age = data.contacts[i].contact_details.dependent.children_age[3].age;
              }
              if (data.contacts[i].contact_details.dependent.how_many_children >= 5) {
                thiss.user_data.fifth_child_age = data.contacts[i].contact_details.dependent.children_age[4].age;
              }
              if (data.contacts[i].contact_details.dependent.how_many_children >= 6) {
                thiss.user_data.sixth_child_age = data.contacts[i].contact_details.dependent.children_age[5].age;
              }
              thiss.employment = data.contacts[i].contact_details.employment_details;
            } else {
              thiss.secondary_applicant = [];
              this.secondary_applicant.push(data.contacts[i]);
              thiss.secondary_applicant_load = true;
              console.log('secondary_applicant', thiss.secondary_applicant);

            }
          }else{
              thiss.user_data.email = data.contacts[0].user_data.email;
              thiss.user_data.mobile_phone = data.contacts[0].user_data.mobile_phone;
              thiss.user_data.firstname = data.contacts[0].user_data.firstname;
              thiss.user_data.middlename = data.contacts[0].user_data.middlename;
              thiss.user_data.lastname = data.contacts[0].user_data.lastname;
              thiss.user_data.date_of_birth = data.contacts[0].user_data.date_of_birth;
              //thiss.user_data.housing_situation = data.contacts[0].contact_details.address[0].housing_situation;
              thiss.user_data.poboxlabel = data.contacts[0].contact_details.address[0].poboxlabel;
              thiss.user_data.floor_number = data.contacts[0].contact_details.address[0].floor_number;
              thiss.user_data.unit_number = data.contacts[0].contact_details.address[0].unit_number;
              thiss.user_data.building_name = data.contacts[0].contact_details.address[0].building_name;
              thiss.user_data.street_number = data.contacts[0].contact_details.address[0].street_number;
              thiss.user_data.street_name = data.contacts[0].contact_details.address[0].street_name;
              thiss.user_data.city = data.contacts[0].contact_details.address[0].city;
              thiss.user_data.state = data.contacts[0].contact_details.address[0].state;
              thiss.user_data.country = data.contacts[0].contact_details.address[0].country;
              thiss.user_data.postcode = data.contacts[0].contact_details.address[0].postcode;
              thiss.user_data.gender = data.contacts[0].contact_details.dependent.gender;
              thiss.user_data.current_marital_status = data.contacts[0].contact_details.dependent.current_marital_status;
              thiss.user_data.how_many_children = data.contacts[0].contact_details.dependent.how_many_children;
              if (data.contacts[0].contact_details.dependent.how_many_children >= 1) {
                thiss.user_data.first_child_age = data.contacts[0].contact_details.dependent.children_age[0].age;
              }
              if (data.contacts[0].contact_details.dependent.how_many_children >= 2) {
                thiss.user_data.second_child_age = data.contacts[0].contact_details.dependent.children_age[1].age;
              }
              if (data.contacts[0].contact_details.dependent.how_many_children >= 3) {
                thiss.user_data.third_child_age = data.contacts[0].contact_details.dependent.children_age[2].age;
              }
              if (data.contacts[0].contact_details.dependent.how_many_children >= 4) {
                thiss.user_data.fourth_child_age = data.contacts[0].contact_details.dependent.children_age[3].age;
              }
              if (data.contacts[0].contact_details.dependent.how_many_children >= 5) {
                thiss.user_data.fifth_child_age = data.contacts[0].contact_details.dependent.children_age[4].age;
              }
              if (data.contacts[0].contact_details.dependent.how_many_children >= 6) {
                thiss.user_data.sixth_child_age = data.contacts[0].contact_details.dependent.children_age[5].age;
              }
              thiss.employment = data.contacts[0].contact_details.employment_details;
          }
          
          //console.log('incomes', thiss.incomes)
        }

      });

    }
  }

  /*Primary contact incomes*/
  getPrimaryIncomes (){
    return this.db.collection<any>( "SDF_income" , ref => ref.where('uid','==',this.contact_uid ).where('deleted','<',1 )).valueChanges ();
  }

  /*Primary contact assets*/
  getPrimaryAssets (){
    return this.db.collection<any>( "SDF_assets" , ref => ref.where('uid','==',this.contact_uid ).where('deleted','<',1 )).valueChanges ();
  }

  /*Primary contact liabilities*/
  getPrimaryLiabilities (){
    return this.db.collection<any>( "SDF_liabilities" , ref => ref.where('uid','==',this.contact_uid ).where('deleted','<',1 )).valueChanges ();
  }

  /*Secondary contact*/
  getSecondaryContact (){
    return this.db.collection<any>( "users" , ref => ref.where('main_contact_uid','==',this.contact_uid ).where('deleted','<',1 )).valueChanges ();
  }

  /*Secondary contact employment*/
  getSecondaryEmployment (){
    return this.db.collection<any>( "employment" , ref => ref.where('uid','==',this.secondary_user_employment )).valueChanges ();
  }

  /*Secondary contact incomes*/
  getSecondaryIncomes (){
    return this.db.collection<any>( "SDF_income" , ref => ref.where('uid','==',this.secondary_user_employment ).where('deleted','<',1 )).valueChanges ();
  }

  /*Secondary contact assets*/
  getSecondaryAssets (){
    return this.db.collection<any>( "SDF_assets" , ref => ref.where('uid','==',this.secondary_user_employment ).where('deleted','<',1 )).valueChanges ();
  }

  /*Secondary contact liabilities*/
  getSecondaryLiabilities (){
    return this.db.collection<any>( "SDF_liabilities" , ref => ref.where('uid','==',this.secondary_user_employment ).where('deleted','<',1 )).valueChanges ();
  }

  getAllRealEstates (){
    return this.db.collection<any>( "SDF_realestate" , ref => ref.where('primary_uid','==',this.contact_uid ).where('deleted','<',1 )).valueChanges ();
  }

  getAllRealEstatesS (){
    return this.db.collection<any>( "SDF_realestate" , ref => ref.where('secondary_uid','==',this.contact_uid ).where('deleted','<',1 )).valueChanges ();
  }

  getAllRealEstateSplits (document_id){
    return this.db.collection<any>( "SDF_realestate/"+document_id+'/mortgage_splits' , ref => ref.where('deleted','<',1 )).valueChanges ();
  }

  getAllTentativeRealEstates (){
    return this.db.collection<any>( "tentative_real_estate" , ref => ref.where('group_id','==',this.t_document_id ).where('deleted','==',0 )).valueChanges ();
  }

  get_user_data (contact_uid, SDF_form_document_id){
    return this.db.collection<any>( "users_data" , ref => ref.where('uid','==',contact_uid).where('SDF_form_document_id','==',SDF_form_document_id).where('deleted','<',1 )).valueChanges ();
  }

  get_second_user_data (SDF_form_document_id){
    return this.db.collection<any>( "users_data" , ref => ref.where('created_date','>',0 ).where('contact_type','==','Secondary Contact').where('SDF_form_document_id','==',SDF_form_document_id).where('deleted','==',0 ).orderBy('created_date', 'asc')).valueChanges ();
  }

  get_SDF_form (SDF_form_document_id){
    return this.db.collection<any>( "SDF_form" , ref => ref.where('id','==',SDF_form_document_id)).valueChanges ();
  }

  get_incomes (SDF_form_document_id){
    return this.db.collection<any>( "SDF_income" , ref => ref.where('created_date','>',0 ).where('SDF_form','==',SDF_form_document_id).where('deleted','==',0).orderBy('created_date', 'asc')).valueChanges ();
  }

  get_assets (SDF_form_document_id){
    return this.db.collection<any>( "SDF_assets" , ref => ref.where('created_date','>',0 ).where('SDF_form','==',SDF_form_document_id).where('deleted','==',0).orderBy('created_date', 'asc')).valueChanges ();
  }

  get_liabilities (SDF_form_document_id){
    return this.db.collection<any>( "SDF_liabilities" , ref => ref.where('created_date','>',0 ).where('SDF_form','==',SDF_form_document_id).where('deleted','==',0).orderBy('created_date', 'asc')).valueChanges ();
  }

  get_realEstates (SDF_form_document_id){
    return this.db.collection<any>( "SDF_realestate" , ref => ref.where('created_date','>',0 ).where('SDF_form','==',SDF_form_document_id).where('deleted','==',0).orderBy('created_date', 'asc')).valueChanges ();
  }

  get_owner (SDF_form_document_id, uid){
    return this.db.collection<any>( "users_data" , ref => ref.where('SDF_form_document_id','==',SDF_form_document_id).where('uid','==',uid).where('deleted','<',1)).valueChanges ();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ViewContactPdfPage');
  }

  formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {

    // console.log(amount);
    //debugger;
    if(Math.ceil(parseFloat(amount)) === amount) {
      console.log(amount);
      try {
        decimalCount = Math.abs(decimalCount);
        // var decimalvalue = amount - Math.floor(amount);
        // console.log(decimalvalue);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
  
        const negativeSign = amount < 0 ? "-" : "";
  
        let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
        let j = (i.length > 3) ? i.length % 3 : 0;
  
        return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands);
      } catch (e) {
      
      }
    }
    else if (amount)
    {
      if(!isNaN(amount) && amount.toString().indexOf('.') != -1){
        console.log(amount);
        console.log('yes');
        const pieces = parseFloat(amount).toFixed(2).split('')
        let ii = pieces.length - 3
        while ((ii-=3) > 0) {
          pieces.splice(ii, 0, ',')
        }
        return pieces.join('')
      }
      
    }​
    else {
      return 0;
    }
    //debugger;
    
  }

  // formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
  //   try {
  //     decimalCount = Math.abs(decimalCount);
  //     decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

  //     const negativeSign = amount < 0 ? "-" : "";

  //     let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
  //     let j = (i.length > 3) ? i.length % 3 : 0;

  //     return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands);
  //   } catch (e) {
  //     console.log(e)
  //   }
  // }

  downloadPdf(customName){
    var thiss = this;
    console.log('this',this.user_data)

    html2canvas(document.getElementById('content'), {allowTaint: true}).then(canvas => {
      var thiss = this;
      //primary contact
      var full_name = this.user_data.firstname +' '+ this.user_data.lastname;
      var address = this.user_data.street_number+' '+this.user_data.street_name+' '+this.user_data.city+' '+this.user_data.state+' '+this.user_data.country+' '+this.user_data.postcode;
      var how_many_children = 'No';
      if(this.user_data.how_many_children > 0){
        how_many_children = this.user_data.how_many_children;
      }
      var primaryValue = [];
      var value1 = [];
      value1.push({text: 'Personal Details', style: 'primaryPersonalEmploymenttitleMain', border: [false, false, false, true], borderColor:['','','','#fff']});
      value1.push({text: '', style: 'primaryPersonalEmploymenttitleMain', border: [false, false, true, true], borderColor:['','','#fff','#fff']});
      value1.push({text: 'Employment Details', style: 'primaryPersonalEmploymenttitleMain', border: [false, false, false, true], borderColor:['','','','#fff']});
      value1.push({text: '', style: 'primaryPersonalEmploymenttitleMain', border: [false, false, false, true], borderColor:['','','','#fff']});
      primaryValue.push(value1);
      value1 = [];
      value1.push({text: 'Full Name : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
      value1.push({text: full_name, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
      value1.push({text: 'Type of Employment : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
      value1.push({text: this.employment.employementType, style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
      primaryValue.push(value1);
      value1 = [];
      value1.push({text: 'Email : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
      value1.push({text: this.user_data.email, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
      if(this.employment.employementType == 'payg'){
        value1.push({text: 'Currently Employed : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
        value1.push({text: this.employment.currentlyEmployment, style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
      }else if(this.employment.employementType == 'self-employed'){
        value1.push({text: 'Business Name : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
        value1.push({text: this.employment.business_name, style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
      }else{
        value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
        value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
      }
      primaryValue.push(value1);
      value1 = [];
      value1.push({text: 'Phone Number : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
      value1.push({text: this.user_data.mobile_phone, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
      if(this.employment.employementType == 'payg' && this.employment.currentlyEmployment == 'yes'){
        value1.push({text: 'Currently Status : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
        value1.push({text: this.employment.statusyourEmployment, style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
      }else if(this.employment.employementType == 'payg' && this.employment.currentlyEmployment == 'no'){
        value1.push({text: 'In how long do you expect to find work? : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
        value1.push({text: this.employment.expectFindWork, style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
      }else if(this.employment.employementType == 'self-employed'){
        value1.push({text: 'Type of Entity : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
        value1.push({text: this.employment.type_of_entity, style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
      }else{
        value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
        value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
      }
      primaryValue.push(value1);
      value1 = [];

      value1.push({text: 'Date of Birth : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
      value1.push({text: this.user_data.date_of_birth, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});

      if(this.employment.employementType == 'payg' && this.employment.currentlyEmployment == 'yes'){
        value1.push({text: 'Your Occupation', style: 'primaryDetailsMain', border: [false, false, false, false]});
        value1.push({text: this.employment.your_occupation, style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
      }else if(this.employment.employementType == 'self-employed'){
        value1.push({text: 'ABN/ACN', style: 'primaryDetailsMain', border: [false, false, false, false]});
        value1.push({text: this.employment.abn_acn, style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
      }else{
        value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
        value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
      }
      primaryValue.push(value1);
      value1 = [];

      value1.push({text: 'Address : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
      value1.push({text: address, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});

      if(this.employment.employementType == 'self-employed'){
        value1.push({text: 'Nature of Business', style: 'primaryDetailsMain', border: [false, false, false, false]});
        value1.push({text: this.employment.abn_acn, style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
      }else{
        value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
        value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
      }
      primaryValue.push(value1);
      value1 = [];

      value1.push({text: 'Marital Status : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
      value1.push({text: this.user_data.current_marital_status, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
      value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
      value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
      primaryValue.push(value1);
      value1 = [];

      value1.push({text: 'How Many Children : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
      value1.push({text: how_many_children, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
      value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
      value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
      primaryValue.push(value1);

      if(this.user_data.how_many_children > 0){
        if(this.user_data.first_child_age > 0){
          value1 = [];
          value1.push({text: 'First Child Age : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
          value1.push({text: this.user_data.first_child_age, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
          value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
          value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
          primaryValue.push(value1);
        }

        if(this.user_data.second_child_age > 0){
          value1 = [];
          value1.push({text: 'Second Child Age : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
          value1.push({text: this.user_data.second_child_age, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
          value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
          value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
          primaryValue.push(value1);
        }

        if(this.user_data.third_child_age > 0){
          value1 = [];
          value1.push({text: 'Third Child Age : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
          value1.push({text: this.user_data.third_child_age, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
          value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
          value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
          primaryValue.push(value1);
        }

        if(this.user_data.fourth_child_age > 0){
          value1 = [];
          value1.push({text: 'Fourth Child Age : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
          value1.push({text: this.user_data.fourth_child_age, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
          value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
          value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
          primaryValue.push(value1);
        }

        if(this.user_data.fifth_child_age > 0){
          value1 = [];
          value1.push({text: 'Fifth Child Age : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
          value1.push({text: this.user_data.fifth_child_age, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
          value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
          value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
          primaryValue.push(value1);
        }

        if(this.user_data.sixth_child_age > 0){
          value1 = [];
          value1.push({text: 'Sixth Child Age : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
          value1.push({text: this.user_data.sixth_child_age, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
          value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
          value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
          primaryValue.push(value1);
        }
      }

      //end primary contact

      //secondary contact
      var secondvalue1 = [];
      //var secondaryvalue = [];
      var secondvalue2 = [];
      if(this.secondary_applicant != undefined){
        if(this.secondary_applicant.length > 0){
          Object.keys(this.secondary_applicant).forEach(function(key) {
            console.log('secondary_applicant', thiss.secondary_applicant);
            var secondaryvalue = [];
            var secondfull_name = thiss.secondary_applicant[key].user_data.firstname +' '+ thiss.secondary_applicant[key].user_data.lastname;
            var secondaddress = '';
            if(thiss.secondary_applicant[key].user_data.city != undefined){
              secondaddress = thiss.secondary_applicant[key].contact_details.address[0].street_number+' '+thiss.secondary_applicant[key].contact_details.address[0].street_name+' '+thiss.secondary_applicant[key].contact_details.address[0].city+' '+thiss.secondary_applicant[key].contact_details.address[0].state+' '+thiss.secondary_applicant[key].contact_details.address[0].country+' '+thiss.secondary_applicant[key].contact_details.address[0].postcode;
            }
            var secondhow_many_children = 'No';
            if(thiss.secondary_applicant[key].contact_details.dependent.how_many_children > 0){
              secondhow_many_children = thiss.secondary_applicant[key].contact_details.dependent.how_many_children;
            }
            secondvalue1 = [];
            secondvalue1.push({text: 'Personal Details', style: 'primaryPersonalEmploymenttitleMain', border: [false, false, false, true], borderColor:['','','','#fff']});
            secondvalue1.push({text: '', style: 'primaryPersonalEmploymenttitleMain', border: [false, false, true, true], borderColor:['','','#fff','#fff']});
            secondvalue1.push({text: 'Employment Details', style: 'primaryPersonalEmploymenttitleMain', border: [false, false, false, true], borderColor:['','','','#fff']});
            secondvalue1.push({text: '', style: 'primaryPersonalEmploymenttitleMain', border: [false, false, false, true], borderColor:['','','','#fff']});
            secondaryvalue.push(secondvalue1);

            secondvalue1 = [];
            secondvalue1.push({text: 'Full Name : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
            secondvalue1.push({text: secondfull_name, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
            secondvalue1.push({text: 'Type of Employment : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
            secondvalue1.push({text: thiss.secondary_applicant[key].contact_details.employment_details.employementType, style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
            secondaryvalue.push(secondvalue1);

            secondvalue1 = [];
            secondvalue1.push({text: 'Email : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
            secondvalue1.push({text: thiss.secondary_applicant[key].user_data.email, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
            if(thiss.secondary_applicant[key].contact_details.employment_details.employementType == 'payg'){
              secondvalue1.push({text: 'Currently Employed : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
              secondvalue1.push({text: thiss.secondary_applicant[key].contact_details.employment_details.currentlyEmployment, style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
            }else if(thiss.secondary_applicant[0].contact_details.employment_details.employementType == 'self-employed'){
              secondvalue1.push({text: 'Business Name : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
              secondvalue1.push({text: thiss.secondary_applicant[key].contact_details.employment_details.business_name, style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
            }else{
              secondvalue1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
              secondvalue1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
            }
            secondaryvalue.push(secondvalue1);

            secondvalue1 = [];
            secondvalue1.push({text: 'Phone Number : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
            secondvalue1.push({text: thiss.secondary_applicant[key].user_data.mobile_phone, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
            if(thiss.secondary_applicant[key].contact_details.employment_details.employementType == 'payg' && thiss.secondary_applicant[key].contact_details.employment_details.currentlyEmployment == 'yes'){
              secondvalue1.push({text: 'Currently Status : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
              secondvalue1.push({text: thiss.secondary_applicant[key].contact_details.employment_details.statusyourEmployment, style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
            }else if(thiss.secondary_applicant[key].contact_details.employment_details.employementType == 'payg' && thiss.secondary_applicant[key].contact_details.employment_details.currentlyEmployment == 'no'){
              secondvalue1.push({text: 'In how long do you expect to find work? : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
              secondvalue1.push({text: thiss.secondary_applicant[key].contact_details.employment_details.expectFindWork, style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
            }else if(thiss.secondary_applicant[key].contact_details.employment_details.employementType == 'self-employed'){
              secondvalue1.push({text: 'Type of Entity : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
              secondvalue1.push({text: thiss.secondary_applicant[key].contact_details.employment_details.type_of_entity, style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
            }else{
              secondvalue1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
              secondvalue1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
            }
            secondaryvalue.push(secondvalue1);

            secondvalue1 = [];
            secondvalue1.push({text: 'Date of Birth : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
            secondvalue1.push({text: thiss.secondary_applicant[key].user_data.date_of_birth, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
            if(thiss.secondary_applicant[key].contact_details.employment_details.employementType == 'payg' && thiss.secondary_applicant[key].contact_details.employment_details.currentlyEmployment == 'yes'){
              secondvalue1.push({text: 'Your Occupation', style: 'primaryDetailsMain', border: [false, false, false, false]});
              secondvalue1.push({text: thiss.secondary_applicant[key].contact_details.employment_details.your_occupation, style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
            }else if(thiss.secondary_applicant[key].contact_details.employment_details.employementType == 'self-employed'){
              secondvalue1.push({text: 'ABN/ACN', style: 'primaryDetailsMain', border: [false, false, false, false]});
              secondvalue1.push({text: thiss.secondary_applicant[key].contact_details.employment_details.abn_acn, style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
            }else{
              secondvalue1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
              secondvalue1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
            }
            secondaryvalue.push(secondvalue1);

            secondvalue1 = [];
            secondvalue1.push({text: 'Address : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
            secondvalue1.push({text: secondaddress, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
            if(thiss.secondary_applicant[key].contact_details.employment_details.employementType == 'self-employed'){
              secondvalue1.push({text: 'Nature of Business', style: 'primaryDetailsMain', border: [false, false, false, false]});
              secondvalue1.push({text: thiss.secondary_applicant[key].contact_details.employment_details.abn_acn, style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
            }else{
              secondvalue1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
              secondvalue1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
            }
            secondaryvalue.push(secondvalue1);

            secondvalue1 = [];
            secondvalue1.push({text: 'Relationship To Primary Applicant : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
            secondvalue1.push({text: thiss.secondary_applicant[key].user_data.relationship_to_primary_applicant, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
            secondvalue1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
            secondvalue1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
            secondaryvalue.push(secondvalue1);

            secondvalue1 = [];
            secondvalue1.push({text: 'Marital Status : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
            secondvalue1.push({text: thiss.secondary_applicant[key].contact_details.dependent.current_marital_status, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
            secondvalue1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
            secondvalue1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
            secondaryvalue.push(secondvalue1);

            secondvalue1 = [];
            secondvalue1.push({text: 'How Many Children : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
            secondvalue1.push({text: secondhow_many_children, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
            secondvalue1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
            secondvalue1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
            secondaryvalue.push(secondvalue1);

            if(thiss.secondary_applicant[key].contact_details.dependent.how_many_children > 0){
              if(thiss.secondary_applicant[key].contact_details.dependent.children_age.length >= 0){
                secondvalue1 = [];
                secondvalue1.push({text: 'First Child Age : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
                secondvalue1.push({text: thiss.secondary_applicant[key].contact_details.dependent.children_age[0], style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
                secondvalue1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
                secondvalue1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
                secondaryvalue.push(secondvalue1);
              }
              if(thiss.secondary_applicant[key].contact_details.dependent.children_age.length >= 1){
                secondvalue1 = [];
                secondvalue1.push({text: 'Second Child Age : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
                secondvalue1.push({text: thiss.secondary_applicant[key].contact_details.dependent.children_age[1], style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
                secondvalue1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
                secondvalue1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
                secondaryvalue.push(secondvalue1);
              }
              if(thiss.secondary_applicant[key].contact_details.dependent.children_age.length >= 2){
                secondvalue1 = [];
                secondvalue1.push({text: 'Third Child Age : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
                secondvalue1.push({text: thiss.secondary_applicant[0].contact_details.dependent.children_age[2], style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
                secondvalue1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
                secondvalue1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
                secondaryvalue.push(secondvalue1);
              }
              if(thiss.secondary_applicant[key].contact_details.dependent.children_age.length >= 3){
                secondvalue1 = [];
                secondvalue1.push({text: 'Fourth Child Age : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
                secondvalue1.push({text: thiss.secondary_applicant[key].contact_details.dependent.children_age[3], style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
                secondvalue1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
                secondvalue1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
                secondaryvalue.push(secondvalue1);
              }
              if(thiss.secondary_applicant[key].contact_details.dependent.children_age.length >= 4){
                secondvalue1 = [];
                secondvalue1.push({text: 'Fifth Child Age : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
                secondvalue1.push({text: thiss.secondary_applicant[key].contact_details.dependent.children_age[4], style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
                secondvalue1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
                secondvalue1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
                secondaryvalue.push(secondvalue1);
              }
              if(thiss.secondary_applicant[key].contact_details.dependent.children_age.length >= 5){
                secondvalue1 = [];
                secondvalue1.push({text: 'Sixth Child Age : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
                secondvalue1.push({text: thiss.secondary_applicant[0].contact_details.dependent.children_age[5], style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
                secondvalue1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
                secondvalue1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
                secondaryvalue.push(secondvalue1);
              }
            }

            var secondval5 = []
            secondval5.push({text: '', border: [false, false, false, false], margin: [0,0,0,20]});
            var secondval6 = [];
            secondval6.push(secondval5);
            var secondval3 = []
            secondval3.push({text: 'Additional Applicant - '+thiss.secondary_applicant[key].user_data.firstname +' '+ thiss.secondary_applicant[key].user_data.lastname, style: 'primary', border: [false, false, false, false]});
            var secondval4 = [];
            secondval4.push(secondval3);
            secondvalue2.push({table: {widths: ['100%'], body: secondval6}});
            secondvalue2.push({table: {widths: ['100%'], margin: [10,10,10,10], body: secondval4}});
            secondvalue2.push({table: {widths: ['25%', '25%', '25%', '25%'], body: secondaryvalue}, layout: {vLineWidth: function(i, node) { return 5; } }});
          });
        }else{
          secondvalue1 = [];
          secondvalue1.push({text: '', style: 'primaryDetails 123', border: [false, false, false, false]});
          secondvalue2.push({table: {widths: ['100%'], body: secondvalue1}, layout: {vLineWidth: function(i, node) { return 5; } }});
        }
      }else{
        secondvalue1 = [];
        secondvalue1.push({text: '', style: 'primaryDetails 456', border: [false, false, false, false]});
        secondvalue2.push({table: {widths: ['100%'], body: secondvalue1}, layout: {vLineWidth: function(i, node) { return 5; } }});
      }
      //end secondary contact



      //real estate table view
      if(thiss.realestates.length > 0){

        var realEstatePDFTableAll = [];
        var realEstatePDFListViewAll = [];
        var realEstatePDFTableAllData = [];

        var realestateval1 = []
        realestateval1.push({text: '', border: [false, false, false, false], margin: [0,0,0,20]});
        var realestateval2 = [];
        realestateval2.push(realestateval1);
        var realestateval3 = []
        realestateval3.push({text: 'Real Estate Asset Summary', style: 'primary', border: [false, false, false, false]});
        var realestateval4 = [];
        realestateval4.push(realestateval3);
        realEstatePDFTableAllData.push({table: {widths: ['100%'], body: realestateval2}});
        realEstatePDFTableAllData.push({table: {widths: ['100%'], body: realestateval4}});

        realEstatePDFListViewAll.push({table: {widths: ['100%'], body: realestateval2}});
        realEstatePDFListViewAll.push({table: {widths: ['100%'], margin: [10,10,10,10], body: realestateval4}});

        var realEstatePDFTable = [];
        realEstatePDFTable.push({text: 'Address', style: 'tableViewTentativeText1'});
        realEstatePDFTable.push({text: 'LVR', style: 'tableViewTentativeText1'});
        realEstatePDFTable.push({text: 'Estimated Current Value', style: 'tableViewTentativeText1'});
        realEstatePDFTable.push({text: 'Ownership (Names)', style: 'tableViewTentativeText1'});
        realEstatePDFTable.push({text: 'Lender', style: 'tableViewTentativeText1'});
        realEstatePDFTable.push({text: 'Current Mortgage Balance', style: 'tableViewTentativeText1'});
        realEstatePDFTable.push({text: 'Redraw/Offset', style: 'tableViewTentativeText1'});
        realEstatePDFTable.push({text: 'Interest Rate', style: 'tableViewTentativeText1'});
        realEstatePDFTable.push({text: 'Fixed or Variable', style: 'tableViewTentativeText1'});
        realEstatePDFTable.push({text: 'Int Only or P&I', style: 'tableViewTentativeText1'});
        realEstatePDFTable.push({text: 'Monthly Repayments', style: 'tableViewTentativeText1'});
        realEstatePDFTable.push({text: 'Rental Income per week', style: 'tableViewTentativeText1'});
        realEstatePDFTable.push({text: 'Rent Annual', style: 'tableViewTentativeText1'});
        realEstatePDFTableAll.push(realEstatePDFTable);

        var realEstateSplitData4 = [];

        thiss.realestates.forEach(function (pdfvalue, pdfkey) {
          if(pdfvalue.itemRowsMortgageSplits.length > 0){
            realEstateSplitData4 = [];
            thiss.realEstateTotalSplitMortgageLimit = parseFloat('0');
            thiss.realEstateTotalSplitCurrentBalance = parseFloat('0');
            thiss.realEstateTotalSplitAvailableRedraw = parseFloat('0');
            thiss.realEstateTotalSplitRepayments = parseFloat('0');
            var realEstateTotalSplitCreditor = '';
            var realEstateTotalSplitInterestRate = '';
            var realEstateTotalSplitInterestRateTerm = '';
            var realEstateTotalSplitLoanType = '';
            pdfvalue.itemRowsMortgageSplits.forEach(function (pdfvalue1, pdfkey1) {

              //real estate table view.
              realEstatePDFTable = [];
              if(pdfkey1 > 0){
                realEstatePDFTable.push({text: 'Loan Split '+pdfkey1, style: 'tableViewTentativeText'});
                realEstatePDFTable.push({text: '', style: 'tableViewTentativeText'});
                realEstatePDFTable.push({text: '', style: 'tableViewTentativeText'});
                realEstatePDFTable.push({text: '', style: 'tableViewTentativeText'});
              }else{
                realEstatePDFTable.push({text: pdfvalue.street_number+' '+pdfvalue.street_name+' '+pdfvalue.city+' '+pdfvalue.state+' '+pdfvalue.country+' '+pdfvalue.postcode, style: 'tableViewTentativeText'});
                realEstatePDFTable.push({text: pdfvalue.lvr+'%', style: 'tableViewTentativeText'});
                realEstatePDFTable.push({text: pdfvalue.asset_value, style: 'tableViewTentativeText'});
                realEstatePDFTable.push({text: pdfvalue.ownership_title_name, style: 'tableViewTentativeText'});
              }
              realEstatePDFTable.push({text: pdfvalue1.creditor, style: 'tableViewTentativeText'});
              realEstatePDFTable.push({text: pdfvalue1.current_balance, style: 'tableViewTentativeText'});
              realEstatePDFTable.push({text: pdfvalue1.available_redraw == undefined ? (pdfvalue1.mortgage_limit-pdfvalue1.current_balance) : pdfvalue1.available_redraw, style: 'tableViewTentativeText'});
              realEstatePDFTable.push({text: pdfvalue1.interest_rate+'%', style: 'tableViewTentativeText'});
              realEstatePDFTable.push({text: pdfvalue1.interest_rate_term, style: 'tableViewTentativeText'});
              realEstatePDFTable.push({text: pdfvalue1.loan_type, style: 'tableViewTentativeText'});
              realEstatePDFTable.push({text: '$'+thiss.formatMoney(pdfvalue.repayments), style: 'tableViewTentativeText'});
              realEstatePDFTable.push({text:  pdfvalue.gross_amount, style: 'tableViewTentativeText'});
              realEstatePDFTable.push({text: '$'+thiss.formatMoney(pdfvalue.rent_annual), style: 'tableViewTentativeText'});
              realEstatePDFTableAll.push(realEstatePDFTable);
              //end real estate table view.


              //real estatae list view.
              //realEstateTotalSplitMortgageLimit += parseInt(pdfvalue1.mortgage_limit);

              if(typeof pdfvalue1.mortgage_limit== "string") {
                var mortgage_limit= pdfvalue1.mortgage_limit.replaceAll(/[`~!@#$%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/]/gi, '');
                //var mortgage_limit = value2.mortgage_limit.replace("$", "");
                thiss.realEstateTotalSplitMortgageLimit = (parseFloat(thiss.realEstateTotalSplitMortgageLimit)+parseFloat(mortgage_limit)).toFixed(2);
              
                thiss.realEstateTotalSplitMortgageLimit = thiss.realEstateTotalSplitMortgageLimit.replace(/^0+/, '');

               }
               if(typeof pdfvalue1.mortgage_limit== "object") {
                //var current_balance = 0;
                pdfvalue1.mortgage_limit = "$ 0.00";
                mortgage_limit=0.00;
                thiss.realEstateTotalSplitMortgageLimit = (parseFloat(thiss.realEstateTotalSplitMortgageLimit)+parseFloat(mortgage_limit)).toFixed(2);
              }
               
              if(typeof pdfvalue1.mortgage_limit == "number") {
                //var current_balance = 0;
                //value2.current_balance = "$ 0.00";
                  mortgage_limit=pdfvalue1.mortgage_limit;
                  thiss.realEstateTotalSplitMortgageLimit = (parseFloat(thiss.realEstateTotalSplitMortgageLimit)+parseFloat(mortgage_limit)).toFixed(2);
                 let new_mortage_limit = parseFloat(mortgage_limit).toFixed(2);
                 pdfvalue1.mortgage_limit= "$ "+thiss.formatMoney(new_mortage_limit);
              }


              if(typeof pdfvalue1.current_balance== "string") {
                var current_balance= pdfvalue1.current_balance.replaceAll(/[`~!@#$%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/]/gi, '');
                //var mortgage_limit = value2.mortgage_limit.replace("$", "");
                thiss.realEstateTotalSplitCurrentBalance = (parseFloat(thiss.realEstateTotalSplitCurrentBalance)+parseFloat(current_balance)).toFixed(2);
              
                thiss.realEstateTotalSplitCurrentBalance = thiss.realEstateTotalSplitCurrentBalance.replace(/^0+/, '');

               }
               if(typeof pdfvalue1.current_balance== "object") {
                //var current_balance = 0;
                pdfvalue1.current_balance = "$ 0.00";
                current_balance=0.00;
                thiss.realEstateTotalSplitCurrentBalance = (parseFloat(thiss.realEstateTotalSplitCurrentBalance)+parseFloat(current_balance)).toFixed(2);
              }
               
              if(typeof pdfvalue1.current_balance == "number") {
                //var current_balance = 0;
                //value2.current_balance = "$ 0.00";
                current_balance=pdfvalue1.current_balance;
                  thiss.realEstateTotalSplitCurrentBalance = (parseFloat(thiss.realEstateTotalSplitCurrentBalance)+parseFloat(current_balance)).toFixed(2);
                 let new_current_balance = parseFloat(current_balance).toFixed(2);
                 pdfvalue1.current_balance= "$ "+thiss.formatMoney(new_current_balance);
              }

              if(typeof pdfvalue1.available_redraw== "string") {
                var available_redraw= pdfvalue1.available_redraw.replaceAll(/[`~!@#$%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/]/gi, '');
                //var mortgage_limit = value2.mortgage_limit.replace("$", "");
                thiss.realEstateTotalSplitAvailableRedraw = (parseFloat(thiss.realEstateTotalSplitAvailableRedraw)+parseFloat(available_redraw)).toFixed(2);
              
                thiss.realEstateTotalSplitAvailableRedraw = thiss.realEstateTotalSplitAvailableRedraw.replace(/^0+/, '');

               }
               if(typeof pdfvalue1.available_redraw== "object") {
                //var current_balance = 0;
                pdfvalue1.available_redraw = "$ 0.00";
                available_redraw=0.00;
                thiss.realEstateTotalSplitAvailableRedraw = (parseFloat(thiss.realEstateTotalSplitAvailableRedraw)+parseFloat(available_redraw)).toFixed(2);
              }
               
              if(typeof pdfvalue1.available_redraw == "number") {
                //var current_balance = 0;
                //value2.current_balance = "$ 0.00";
                available_redraw=pdfvalue1.available_redraw;
                  thiss.realEstateTotalSplitAvailableRedraw = (parseFloat(thiss.realEstateTotalSplitAvailableRedraw)+parseFloat(available_redraw)).toFixed(2);
                 let new_available_redraw= parseFloat(available_redraw).toFixed(2);
                 pdfvalue1.available_redraw= "$ "+thiss.formatMoney(new_available_redraw);
              }

              if(typeof pdfvalue1.repayments== "string") {
                var repayments= pdfvalue1.repayments.replaceAll(/[`~!@#$%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/]/gi, '');
                //var mortgage_limit = value2.mortgage_limit.replace("$", "");
                thiss.realEstateTotalSplitRepayments = (parseFloat(thiss.realEstateTotalSplitRepayments)+parseFloat(repayments)).toFixed(2);
              
                thiss.realEstateTotalSplitRepayments = thiss.realEstateTotalSplitRepayments.replace(/^0+/, '');

               }
               if(typeof pdfvalue1.repayments== "object") {
                //var current_balance = 0;
                pdfvalue1.repayments = "$ 0.00";
                repayments=0.00;
                thiss.realEstateTotalSplitRepayments = (parseFloat(thiss.realEstateTotalSplitRepayments)+parseFloat(repayments)).toFixed(2);
              }
               
              if(typeof pdfvalue1.repayments == "number") {
                //var current_balance = 0;
                //value2.current_balance = "$ 0.00";
                repayments=pdfvalue1.repayments;
                  thiss.realEstateTotalSplitRepayments = (parseFloat(thiss.realEstateTotalSplitRepayments)+parseFloat(repayments)).toFixed(2);
                 let new_repayments= parseFloat(repayments).toFixed(2);
                 pdfvalue1.repayments= "$ "+thiss.formatMoney(new_repayments);
              }

              //thiss.realEstateTotalSplitCurrentBalance += parseInt(pdfvalue1.current_balance);
              //thiss.realEstateTotalSplitAvailableRedraw += (pdfvalue1.available_redraw == undefined) ? (parseInt(pdfvalue1.mortgage_limit)-parseInt(pdfvalue1.current_balance)) : parseInt(pdfvalue1.available_redraw);
              //thiss.realEstateTotalSplitRepayments += parseInt(pdfvalue1.repayments);
              realEstateTotalSplitCreditor = pdfvalue1.creditor;
              realEstateTotalSplitInterestRate = pdfvalue1.interest_rate;
              realEstateTotalSplitInterestRateTerm = pdfvalue1.interest_rate_term;
              realEstateTotalSplitLoanType = pdfvalue1.loan_type;

              var realEstateSplitData = [];
              var realEstateSplitData1 = [];
              if(pdfkey1 == 0){
                realEstateSplitData.push({text: 'Existing Mortgage', style: 'realEstateSplitTitle', colSpan: 4, border: [false, false, false, false]});
              }else{
                realEstateSplitData.push({text: 'Loan Split '+pdfkey1, style: 'realEstateSplitTitle', colSpan: 4, border: [false, false, false, false]});
              }
              realEstateSplitData.push({text: '', style: 'realEstateSplit', border: [false, false, true, false], borderColor:['','','#fff','']});
              realEstateSplitData.push({text: '', style: 'realEstateSplit', border: [false, false, false, false]});
              realEstateSplitData.push({text: '', style: 'realEstateSplit', border: [false, false, false, false], alignment: 'right'});
              realEstateSplitData1.push(realEstateSplitData);

              realEstateSplitData = [];
              realEstateSplitData.push({text: 'Lender : ', style: 'realEstateSplit1', border: [false, false, false, false]});
              realEstateSplitData.push({text: pdfvalue1.creditor, style: 'realEstateSplit', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
              realEstateSplitData.push({text: 'Current Mortgage Balance : ', style: 'realEstateSplit1', border: [false, false, false, false]});
              realEstateSplitData.push({text: pdfvalue1.current_balance, style: 'realEstateSplit', border: [false, false, false, false], alignment: 'right'});
              realEstateSplitData1.push(realEstateSplitData);

              realEstateSplitData = [];
              realEstateSplitData.push({text: 'Int Only or P&I : ', style: 'realEstateSplit1', border: [false, false, false, false]});
              realEstateSplitData.push({text: pdfvalue1.loan_type, style: 'realEstateSplit', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
              realEstateSplitData.push({text: 'Funds in Offset or Redraw : ', style: 'realEstateSplit1', border: [false, false, false, false]});
              realEstateSplitData.push({text: pdfvalue1.available_redraw == undefined ? (parseInt(pdfvalue1.mortgage_limit)-parseInt(pdfvalue1.current_balance)) : pdfvalue1.available_redraw, style: 'realEstateSplit', border: [false, false, false, false], alignment: 'right'});
              realEstateSplitData1.push(realEstateSplitData);

              realEstateSplitData = [];
              realEstateSplitData.push({text: 'Interest Rate : ', style: 'realEstateSplit1', border: [false, false, false, false]});
              realEstateSplitData.push({text: pdfvalue1.interest_rate+'%', style: 'realEstateSplit', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
              realEstateSplitData.push({text: 'Monthly Repayments', style: 'realEstateSplit1', border: [false, false, false, false]});
              realEstateSplitData.push({text: pdfvalue1.repayments, style: 'realEstateSplit', border: [false, false, false, false], alignment: 'right'});
              realEstateSplitData1.push(realEstateSplitData);

              realEstateSplitData = [];
              realEstateSplitData.push({text: 'Fixed or Variable : ', style: 'realEstateSplit1', border: [false, false, false, false]});
              realEstateSplitData.push({text: pdfvalue1.interest_rate_term, style: 'realEstateSplit', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
              realEstateSplitData.push({text: '', style: 'realEstateSplit', border: [false, false, false, false]});
              realEstateSplitData.push({text: '', style: 'realEstateSplit', border: [false, false, false, false], alignment: 'right'});
              realEstateSplitData1.push(realEstateSplitData);

              var realEstateSplitData3 = [];
              realEstateSplitData3.push({style: 'primaryDetails', colSpan: 4, table: {widths: ['25%', '25%', '25%', '25%'], body: realEstateSplitData1}});


              realEstateSplitData4.push(realEstateSplitData3);
              //end real estate list view

            });

            //real estate list view
            if(pdfvalue.itemRowsMortgageSplits.length > 1){
              var realEstateData1 = [];
              var realEstateData = [];
              realEstateData.push({text: 'Address : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
              realEstateData.push({text: pdfvalue.street_number+' '+pdfvalue.street_name+' '+pdfvalue.city+' '+pdfvalue.state+' '+pdfvalue.country+' '+pdfvalue.postcode, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
              realEstateData.push({text: 'Estimated Current Value : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
              realEstateData.push({text: pdfvalue.asset_value, style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
              realEstateData1.push(realEstateData);

               realEstateData = [];
              realEstateData.push({text: 'Ownership (Names) : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
              realEstateData.push({text: pdfvalue.ownership_title_name, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
              realEstateData.push({text: 'Current Mortgage Balance : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
              realEstateData.push({text: '$'+thiss.formatMoney(thiss.realEstateTotalSplitCurrentBalance), style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
              realEstateData1.push(realEstateData);

               realEstateData = [];
              realEstateData.push({text: 'LVR : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
              realEstateData.push({text: pdfvalue.lvr+'%', style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
              realEstateData.push({text: 'Funds in Offset or Redraw : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
              realEstateData.push({text: '$'+thiss.formatMoney(thiss.realEstateTotalSplitAvailableRedraw), style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
              realEstateData1.push(realEstateData);

         

               realEstateData = [];
              realEstateData.push({text: ' ', style: 'primaryDetails', border: [false, false, false, false]});
              realEstateData.push({text: '', style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
              realEstateData.push({text: 'Monthly Repayments', style: 'primaryDetailsMain', border: [false, false, false, false]});
              realEstateData.push({text: '$'+thiss.formatMoney(thiss.realEstateTotalSplitRepayments), style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
              realEstateData1.push(realEstateData);

               realEstateData = [];
              realEstateData.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
              realEstateData.push({text: '', style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
              realEstateData.push({text: 'Rental Income per week', style: 'primaryDetailsMain', border: [false, false, false, false]});
              realEstateData.push({text: pdfvalue.gross_amount, style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
              realEstateData1.push(realEstateData);

               realEstateData = [];
              realEstateData.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
              realEstateData.push({text: '', style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
              realEstateData.push({text: 'Rent Annual', style: 'primaryDetailsMain', border: [false, false, false, false]});
              realEstateData.push({text: '$'+thiss.formatMoney(pdfvalue.rent_annual), style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
              realEstateData1.push(realEstateData);

              realEstatePDFListViewAll.push({table: {widths: ['25%', '25%', '25%', '25%'], body: realEstateSplitData4}, layout: {vLineColor: function(i, node) {return '#f7f7f7';},hLineColor: function(i, node) {return '#f7f7f7;';}}});
              realEstatePDFListViewAll.push({table: {widths: ['25%', '25%', '25%', '25%'], body: realEstateData1}, layout: {vLineColor: function(i, node) {return '#f7f7f7';},hLineColor: function(i, node) {return '#f7f7f7;';}}});

              var marginTop = [];
              marginTop.push({text: '', border: [false, false, false, false], margin: [0,0,0,10]});
              realEstatePDFListViewAll.push({table: {widths: ['100%'], body: marginTop}});

            }else{
              var realEstateData1 = [];
               realEstateData = [];
              realEstateData.push({text: 'Address : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
              realEstateData.push({text: pdfvalue.street_number+' '+pdfvalue.street_name+' '+pdfvalue.city+' '+pdfvalue.state+' '+pdfvalue.country+' '+pdfvalue.postcode, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
              realEstateData.push({text: 'Estimated Current Value : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
              realEstateData.push({text: pdfvalue.asset_value, style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
              realEstateData1.push(realEstateData);

              realEstateData = [];
              realEstateData.push({text: 'Ownership (Names) : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
              realEstateData.push({text: pdfvalue.ownership_title_name, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
              realEstateData.push({text: 'Current Mortgage Balance : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
              realEstateData.push({text: '$'+thiss.formatMoney(thiss.realEstateTotalSplitCurrentBalance), style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
              realEstateData1.push(realEstateData);

              realEstateData = [];
              realEstateData.push({text: 'LVR : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
              realEstateData.push({text: pdfvalue.lvr+'%', style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
              realEstateData.push({text: 'Funds in Offset or Redraw : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
              realEstateData.push({text: '$'+thiss.formatMoney(thiss.realEstateTotalSplitAvailableRedraw), style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
              realEstateData1.push(realEstateData);

              realEstateData = [];
              realEstateData.push({text: 'Lender', style: 'primaryDetailsMain', border: [false, false, false, false]});
              realEstateData.push({text: realEstateTotalSplitCreditor, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
              realEstateData.push({text: 'Monthly Repayments', style: 'primaryDetailsMain', border: [false, false, false, false]});
              realEstateData.push({text: '$'+thiss.formatMoney(thiss.realEstateTotalSplitRepayments), style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
              realEstateData1.push(realEstateData);

              realEstateData = [];
              realEstateData.push({text: 'Interest Rate', style: 'primaryDetailsMain', border: [false, false, false, false]});
              realEstateData.push({text: realEstateTotalSplitInterestRate+'%', style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
              realEstateData.push({text: 'Rental Income per week', style: 'primaryDetailsMain', border: [false, false, false, false]});
              realEstateData.push({text:  pdfvalue.gross_amount, style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
              realEstateData1.push(realEstateData);

              realEstateData = [];
              realEstateData.push({text: 'Fixed or Variable', style: 'primaryDetailsMain', border: [false, false, false, false]});
              realEstateData.push({text: realEstateTotalSplitInterestRateTerm, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
              realEstateData.push({text: 'Rent Annual', style: 'primaryDetailsMain', border: [false, false, false, false]});
              realEstateData.push({text: '$'+thiss.formatMoney(pdfvalue.rent_annual), style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
              realEstateData1.push(realEstateData);

              realEstateData = [];
              realEstateData.push({text: 'Int Only or P&I', style: 'primaryDetailsMain', border: [false, false, false, false]});
              realEstateData.push({text: realEstateTotalSplitLoanType, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
              realEstateData.push({text: '', style: 'primaryDetailsMain', border: [false, false, false, false]});
              realEstateData.push({text: '', style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
              realEstateData1.push(realEstateData);

              // var realEstateData = [];
              // realEstateData.push({text: 'Created Date', style: 'primaryDetailsMain', border: [false, false, false, false]});
              // realEstateData.push({text: realEstateTotalSplitLoanType, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
              // realEstateData.push({text: '', style: 'primaryDetailsMain', border: [false, false, false, false]});
              // realEstateData.push({text: '', style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
              // realEstateData1.push(realEstateData);

              // var realEstateData = [];
              // realEstateData.push({text: 'Notes', style: 'primaryDetailsMain', border: [false, false, false, false]});
              // realEstateData.push({text: realEstateTotalSplitLoanType, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
              // realEstateData.push({text: '', style: 'primaryDetailsMain', border: [false, false, false, false]});
              // realEstateData.push({text: '', style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
              // realEstateData1.push(realEstateData);

              realEstatePDFListViewAll.push({table: {widths: ['25%', '25%', '25%', '25%'], body: realEstateData1}, layout: {vLineColor: function(i, node) {return '#f7f7f7';},hLineColor: function(i, node) {return '#f7f7f7;';}}});

               marginTop = [];
              marginTop.push({text: '', border: [false, false, false, false], margin: [0,0,0,10]});
              realEstatePDFListViewAll.push({table: {widths: ['100%'], body: marginTop}});

            }
            //end real estate list view
          }
        });
        //real estate table view.
        // realEstatePDFTable = [];
        // realEstatePDFTable.push({text: 'Totals', style: 'tableViewTentativeText1'});
        // realEstatePDFTable.push({text: this.total_lvr+'%', style: 'tableViewTentativeText1'});
        // realEstatePDFTable.push({text: '$'+this.formatMoney(this.total_asset_value), style: 'tableViewTentativeText1'});
        // realEstatePDFTable.push({text: '', style: 'tableViewTentativeText1'});
        // realEstatePDFTable.push({text: '', style: 'tableViewTentativeText1'});
        // realEstatePDFTable.push({text: '$'+this.formatMoney(this.total_current_balance), style: 'tableViewTentativeText1'});
        // realEstatePDFTable.push({text: '$'+this.formatMoney(this.total_available_redraw), style: 'tableViewTentativeText1'});
        // realEstatePDFTable.push({text: '', style: 'tableViewTentativeText1'});
        // realEstatePDFTable.push({text: '', style: 'tableViewTentativeText1'});
        // realEstatePDFTable.push({text: '', style: 'tableViewTentativeText1'});
        // realEstatePDFTable.push({text: '$'+this.formatMoney(this.total_repayments), style: 'tableViewTentativeText1'});
        // realEstatePDFTable.push({text: '$'+this.formatMoney(this.total_gross_amount), style: 'tableViewTentativeText1'});
        // realEstatePDFTable.push({text: '$'+this.formatMoney(this.total_rent_annual), style: 'tableViewTentativeText1'});
        // realEstatePDFTableAll.push(realEstatePDFTable);
        // realEstatePDFTableAllData.push({table: {body: realEstatePDFTableAll}, layout: {vLineColor: function(i, node) {return '#29718c';},hLineColor: function(i, node) {return '#29718c;';}}});
        // //real estate table view.

        // //real estate list view
        // var realEstateData1 = [];
        // var realEstateData = [];
        // realEstateData.push({image: 'data:image/jpeg;base64,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', fit: [250, 150], rowSpan: 8, style: 'totalWithImage', border: [false, false, false, false]});
        // realEstateData.push({text: '', style: 'totalWithImage', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
        // realEstateData.push({text: 'LVR : ', style: 'totalWithImageMain', border: [false, false, false, false]});
        // realEstateData.push({text: this.total_lvr+'%', style: 'totalWithImage', border: [false, false, false, false], alignment: 'right'});
        // realEstateData1.push(realEstateData);

        // realEstateData = [];
        // realEstateData.push({text: '', style: 'totalWithImage', border: [false, false, false, false]});
        // realEstateData.push({text: '', style: 'totalWithImage', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
        // realEstateData.push({text: 'Estimated Current Value : ', style: 'totalWithImageMain', border: [false, false, false, false]});
        // realEstateData.push({text: '$'+thiss.formatMoney(this.total_asset_value), style: 'totalWithImage', border: [false, false, false, false], alignment: 'right'});
        // realEstateData1.push(realEstateData);

        // realEstateData = [];
        // realEstateData.push({text: '', style: 'totalWithImage', border: [false, false, false, false]});
        // realEstateData.push({text: '', style: 'totalWithImage', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
        // realEstateData.push({text: 'Current Mortgage Balance : ', style: 'totalWithImageMain', border: [false, false, false, false]});
        // realEstateData.push({text: '$'+thiss.formatMoney(this.total_current_balance), style: 'totalWithImage', border: [false, false, false, false], alignment: 'right'});
        // realEstateData1.push(realEstateData);

        // realEstateData = [];
        // realEstateData.push({text: '', style: 'totalWithImage', border: [false, false, false, false]});
        // realEstateData.push({text: '', style: 'totalWithImage', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
        // realEstateData.push({text: 'Funds in Offset or Redraw : ', style: 'totalWithImageMain', border: [false, false, false, false]});
        // realEstateData.push({text: '$'+thiss.formatMoney(this.total_available_redraw), style: 'totalWithImage', border: [false, false, false, false], alignment: 'right'});
        // realEstateData1.push(realEstateData);

        // realEstateData = [];
        // realEstateData.push({text: '', style: 'totalWithImage', border: [false, false, false, false]});
        // realEstateData.push({text: '', style: 'totalWithImage', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
        // realEstateData.push({text: 'Monthly Repayments', style: 'totalWithImageMain', border: [false, false, false, false]});
        // realEstateData.push({text: '$'+thiss.formatMoney(this.total_repayments), style: 'totalWithImage', border: [false, false, false, false], alignment: 'right'});
        // realEstateData1.push(realEstateData);

        // realEstateData = [];
        // realEstateData.push({text: '', style: 'totalWithImage', border: [false, false, false, false]});
        // realEstateData.push({text: '', style: 'totalWithImage', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
        // realEstateData.push({text: 'Rental Income per week', style: 'totalWithImageMain', border: [false, false, false, false]});
        // realEstateData.push({text: '$'+thiss.formatMoney(this.total_gross_amount), style: 'totalWithImage', border: [false, false, false, false], alignment: 'right'});
        // realEstateData1.push(realEstateData);

        // realEstateData = [];
        // realEstateData.push({text: '', style: 'totalWithImage', border: [false, false, false, false]});
        // realEstateData.push({text: '', style: 'totalWithImage', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
        // realEstateData.push({text: 'Rent Annual', style: 'totalWithImageMain', border: [false, false, false, false]});
        // realEstateData.push({text: '$'+thiss.formatMoney(this.total_rent_annual), style: 'totalWithImage', border: [false, false, false, false], alignment: 'right'});
        // realEstateData1.push(realEstateData);

        // realEstateData = [];
        // realEstateData.push({text: '', style: 'totalWithImage', border: [false, false, false, false]});
        // realEstateData.push({text: '', style: 'totalWithImage', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
        // realEstateData.push({text: '', style: 'totalWithImageMain', border: [false, false, false, false]});
        // realEstateData.push({text: '', style: 'totalWithImage', border: [false, false, false, false], alignment: 'right'});
        // realEstateData1.push(realEstateData);

        // realEstatePDFListViewAll.push({table: {widths: ['25%', '25%', '25%', '25%'], body: realEstateData1}, layout: {vLineColor: function(i, node) {return '#f7f7f7';},hLineColor: function(i, node) {return '#f7f7f7;';}}});
        //end real estate list view
      }else{
         realEstatePDFTable = [];
         realEstatePDFListViewAll = [];
        realEstatePDFTable.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
        realEstatePDFListViewAll.push({table: {widths: ['100%'], body: realEstatePDFTable}, layout: {vLineWidth: function(i, node) { return 5; } }});

        realEstatePDFTable = [];
         realEstatePDFTableAllData = [];
        realEstatePDFTable.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
        realEstatePDFTableAllData.push({table: {widths: ['100%'], body: realEstatePDFTable}, layout: {vLineWidth: function(i, node) { return 5; } }});
      }
      if(this.showHideRealtable){
         realEstatePDFTable = [];
         realEstatePDFListViewAll = [];
        realEstatePDFTable.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
        realEstatePDFListViewAll.push({table: {widths: ['100%'], body: realEstatePDFTable}, layout: {vLineWidth: function(i, node) { return 5; } }});
      }else{
         realEstatePDFTable = [];
         realEstatePDFTableAllData = [];
        realEstatePDFTable.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
        realEstatePDFTableAllData.push({table: {widths: ['100%'], body: realEstatePDFTable}, layout: {vLineWidth: function(i, node) { return 5; } }});
      }
      //end real estate table view

      //tentative real estate table view
      if(this.tentativerealestates.length > 0){

        var tentativerealEstatePDFTableAll = [];
        var tentativerealEstatePDFListViewAll = [];
        var tentativerealEstatePDFTableAllData = [];

        var tentativerealestateval1 = []
        tentativerealestateval1.push({text: '', border: [false, false, false, false], margin: [0,0,0,20]});
        var tentativerealestateval2 = [];
        tentativerealestateval2.push(tentativerealestateval1);
        var tentativerealestateval3 = []
        tentativerealestateval3.push({text: 'Tentative Real Estate Asset Summary', style: 'primary', border: [false, false, false, false]});
        var tentativerealestateval4 = [];
        tentativerealestateval4.push(tentativerealestateval3);
        tentativerealEstatePDFTableAllData.push({table: {widths: ['100%'], body: tentativerealestateval2}});
        tentativerealEstatePDFTableAllData.push({table: {widths: ['100%'], body: tentativerealestateval4}});

        tentativerealEstatePDFListViewAll.push({table: {widths: ['100%'], body: tentativerealestateval2}});
        tentativerealEstatePDFListViewAll.push({table: {widths: ['100%'], margin: [10,10,10,10], body: tentativerealestateval4}});

        var tentativerealEstatePDFTable = [];
        tentativerealEstatePDFTable.push({text: 'Address', style: 'tableViewTentativeText1'});
        tentativerealEstatePDFTable.push({text: 'LVR', style: 'tableViewTentativeText1'});
        tentativerealEstatePDFTable.push({text: 'Estimated Current Value', style: 'tableViewTentativeText1'});
        tentativerealEstatePDFTable.push({text: 'Ownership (Names)', style: 'tableViewTentativeText1'});
        tentativerealEstatePDFTable.push({text: 'Lender', style: 'tableViewTentativeText1'});
        tentativerealEstatePDFTable.push({text: 'Current Mortgage Limit', style: 'tableViewTentativeText1'});
        tentativerealEstatePDFTable.push({text: 'Redraw/Offset', style: 'tableViewTentativeText1'});
        tentativerealEstatePDFTable.push({text: 'Interest Rate', style: 'tableViewTentativeText1'});
        tentativerealEstatePDFTable.push({text: 'Fixed or Variable', style: 'tableViewTentativeText1'});
        tentativerealEstatePDFTable.push({text: 'Int Only or P&I', style: 'tableViewTentativeText1'});
        tentativerealEstatePDFTable.push({text: 'Monthly Repayments', style: 'tableViewTentativeText1'});
        tentativerealEstatePDFTable.push({text: 'Rental Income per week', style: 'tableViewTentativeText1'});
        tentativerealEstatePDFTable.push({text: 'Rent Annual', style: 'tableViewTentativeText1'});
        tentativerealEstatePDFTableAll.push(tentativerealEstatePDFTable);

        var tentativerealEstateSplitData4 = [];

        this.tentativerealestates[0].forEach(function (tentativepdfvalue, tentativepdfkey) {
          if(tentativepdfvalue.itemRowsMortgageSplits.length > 0){
            tentativerealEstateSplitData4 = [];
            var tentativerealEstateTotalSplitMortgageLimit = parseInt('0');
            var tentativerealEstateTotalSplitCurrentBalance = parseInt('0');
            var tentativerealEstateTotalSplitRepayments = parseInt('0');
            var tentativerealEstateTotalSplitCreditor = '';
            var tentativerealEstateTotalSplitInterestRate = '';
            var tentativerealEstateTotalSplitInterestRateTerm = '';
            var tentativerealEstateTotalSplitLoanType = '';
            //real estate table view.
            if(tentativepdfkey != thiss.tentativerealestates[0].length-1){
              tentativepdfvalue.itemRowsMortgageSplits.forEach(function (tentativepdfvalue1, tentativepdfkey1) {
                tentativerealEstatePDFTable = [];
                if(tentativepdfkey1 > 0){
                  tentativerealEstatePDFTable.push({text: 'Loan Split '+tentativepdfkey1, style: 'tableViewTentativeText'});
                  tentativerealEstatePDFTable.push({text: '', style: 'tableViewTentativeText'});
                  tentativerealEstatePDFTable.push({text: '', style: 'tableViewTentativeText'});
                  tentativerealEstatePDFTable.push({text: '', style: 'tableViewTentativeText'});
                }else{
                  tentativerealEstatePDFTable.push({text: tentativepdfvalue.street_number+' '+tentativepdfvalue.street_name+' '+tentativepdfvalue.city+' '+tentativepdfvalue.state+' '+tentativepdfvalue.country+' '+tentativepdfvalue.postcode, style: 'tableViewTentativeText'});
                  tentativerealEstatePDFTable.push({text: tentativepdfvalue.lvr+'%', style: 'tableViewTentativeText'});
                  tentativerealEstatePDFTable.push({text: '$'+thiss.formatMoney(tentativepdfvalue.asset_value), style: 'tableViewTentativeText'});
                  tentativerealEstatePDFTable.push({text: tentativepdfvalue.ownership_title_name, style: 'tableViewTentativeText'});
                }
                tentativerealEstatePDFTable.push({text: tentativepdfvalue1.creditor, style: 'tableViewTentativeText'});
                tentativerealEstatePDFTable.push({text: '$'+thiss.formatMoney(tentativepdfvalue1.mortgage_limit), style: 'tableViewTentativeText'});
                tentativerealEstatePDFTable.push({text: '$'+thiss.formatMoney(tentativepdfvalue1.current_balance), style: 'tableViewTentativeText'});
                tentativerealEstatePDFTable.push({text: tentativepdfvalue1.interest_rate+'%', style: 'tableViewTentativeText'});
                tentativerealEstatePDFTable.push({text: tentativepdfvalue1.interest_rate_term, style: 'tableViewTentativeText'});
                tentativerealEstatePDFTable.push({text: tentativepdfvalue1.loan_type, style: 'tableViewTentativeText'});
                tentativerealEstatePDFTable.push({text: '$'+thiss.formatMoney(tentativepdfvalue.repayments), style: 'tableViewTentativeText'});
                tentativerealEstatePDFTable.push({text: '$'+thiss.formatMoney(tentativepdfvalue.gross_amount), style: 'tableViewTentativeText'});
                tentativerealEstatePDFTable.push({text: '$'+thiss.formatMoney(tentativepdfvalue.rent_annual), style: 'tableViewTentativeText'});
                tentativerealEstatePDFTableAll.push(tentativerealEstatePDFTable);
              });
            }else{
              tentativerealEstatePDFTable = [];
              tentativerealEstatePDFTable.push({text: 'Totals', style: 'tableViewTentativeText1'});
              tentativerealEstatePDFTable.push({text: tentativepdfvalue.lvr+'%', style: 'tableViewTentativeText1'});
              tentativerealEstatePDFTable.push({text: '$'+thiss.formatMoney(tentativepdfvalue.asset_value), style: 'tableViewTentativeText1'});
              tentativerealEstatePDFTable.push({text: '', style: 'tableViewTentativeText1'});
              tentativerealEstatePDFTable.push({text: '', style: 'tableViewTentativeText1'});
              tentativerealEstatePDFTable.push({text: '$'+thiss.formatMoney(tentativepdfvalue.mortgage_limit), style: 'tableViewTentativeText1'});
              tentativerealEstatePDFTable.push({text: '$'+thiss.formatMoney(tentativepdfvalue.current_balance), style: 'tableViewTentativeText1'});
              tentativerealEstatePDFTable.push({text: '', style: 'tableViewTentativeText1'});
              tentativerealEstatePDFTable.push({text: '', style: 'tableViewTentativeText1'});
              tentativerealEstatePDFTable.push({text: '', style: 'tableViewTentativeText1'});
              tentativerealEstatePDFTable.push({text: '$'+thiss.formatMoney(tentativepdfvalue.repayments), style: 'tableViewTentativeText1'});
              tentativerealEstatePDFTable.push({text: '$'+thiss.formatMoney(tentativepdfvalue.gross_amount), style: 'tableViewTentativeText1'});
              tentativerealEstatePDFTable.push({text: '$'+thiss.formatMoney(tentativepdfvalue.rent_annual), style: 'tableViewTentativeText1'});
              tentativerealEstatePDFTableAll.push(tentativerealEstatePDFTable);
            }
            //end real estate table view.

            //real estatae list view.
            tentativepdfvalue.itemRowsMortgageSplits.forEach(function (tentativepdfvalue1, tentativepdfkey1) {
              tentativerealEstateTotalSplitMortgageLimit += parseInt(tentativepdfvalue1.mortgage_limit);
              tentativerealEstateTotalSplitCurrentBalance += parseInt(tentativepdfvalue1.current_balance);
              tentativerealEstateTotalSplitRepayments += parseInt(tentativepdfvalue1.repayments);
              tentativerealEstateTotalSplitCreditor = tentativepdfvalue1.creditor;
              tentativerealEstateTotalSplitInterestRate = tentativepdfvalue1.interest_rate;
              tentativerealEstateTotalSplitInterestRateTerm = tentativepdfvalue1.interest_rate_term;
              tentativerealEstateTotalSplitLoanType = tentativepdfvalue1.loan_type;

              var tentativerealEstateSplitData = [];
              var tentativerealEstateSplitData1 = [];
              if(tentativepdfkey1 == 0){
                tentativerealEstateSplitData.push({text: 'Existing Mortgage', style: 'realEstateSplitTitle', colSpan: 4, border: [false, false, false, false]});
              }else{
                tentativerealEstateSplitData.push({text: 'Loan Split '+tentativepdfkey1, style: 'realEstateSplitTitle', colSpan: 4, border: [false, false, false, false]});
              }
              tentativerealEstateSplitData.push({text: '', style: 'realEstateSplit', border: [false, false, true, false], borderColor:['','','#fff','']});
              tentativerealEstateSplitData.push({text: '', style: 'realEstateSplit', border: [false, false, false, false]});
              tentativerealEstateSplitData.push({text: '', style: 'realEstateSplit', border: [false, false, false, false], alignment: 'right'});
              tentativerealEstateSplitData1.push(tentativerealEstateSplitData);

              tentativerealEstateSplitData = [];
              tentativerealEstateSplitData.push({text: 'Lender : ', style: 'realEstateSplit1', border: [false, false, false, false]});
              tentativerealEstateSplitData.push({text: tentativepdfvalue1.creditor, style: 'realEstateSplit', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
              tentativerealEstateSplitData.push({text: 'Current Mortgage Limit : ', style: 'realEstateSplit1', border: [false, false, false, false]});
              tentativerealEstateSplitData.push({text: '$'+thiss.formatMoney(tentativepdfvalue1.mortgage_limit), style: 'realEstateSplit', border: [false, false, false, false], alignment: 'right'});
              tentativerealEstateSplitData1.push(tentativerealEstateSplitData);

              tentativerealEstateSplitData = [];
              tentativerealEstateSplitData.push({text: 'Int Only or P&I : ', style: 'realEstateSplit1', border: [false, false, false, false]});
              tentativerealEstateSplitData.push({text: tentativepdfvalue1.loan_type, style: 'realEstateSplit', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
              tentativerealEstateSplitData.push({text: 'Funds in Offset or Redraw : ', style: 'realEstateSplit1', border: [false, false, false, false]});
              tentativerealEstateSplitData.push({text: '$'+thiss.formatMoney(tentativepdfvalue1.current_balance), style: 'realEstateSplit', border: [false, false, false, false], alignment: 'right'});
              tentativerealEstateSplitData1.push(tentativerealEstateSplitData);

              tentativerealEstateSplitData = [];
              tentativerealEstateSplitData.push({text: 'Interest Rate : ', style: 'realEstateSplit1', border: [false, false, false, false]});
              tentativerealEstateSplitData.push({text: tentativepdfvalue1.interest_rate+'%', style: 'realEstateSplit', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
              tentativerealEstateSplitData.push({text: 'Monthly Repayments', style: 'realEstateSplit1', border: [false, false, false, false]});
              tentativerealEstateSplitData.push({text: '$'+thiss.formatMoney(tentativepdfvalue1.repayments), style: 'realEstateSplit', border: [false, false, false, false], alignment: 'right'});
              tentativerealEstateSplitData1.push(tentativerealEstateSplitData);

              tentativerealEstateSplitData = [];
              tentativerealEstateSplitData.push({text: 'Fixed or Variable : ', style: 'realEstateSplit1', border: [false, false, false, false]});
              tentativerealEstateSplitData.push({text: tentativepdfvalue1.interest_rate_term, style: 'realEstateSplit', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
              tentativerealEstateSplitData.push({text: '', style: 'realEstateSplit', border: [false, false, false, false]});
              tentativerealEstateSplitData.push({text: '', style: 'realEstateSplit', border: [false, false, false, false], alignment: 'right'});
              tentativerealEstateSplitData1.push(tentativerealEstateSplitData);

              var tentativerealEstateSplitData3 = [];
              tentativerealEstateSplitData3.push({style: 'primaryDetails', colSpan: 4, table: {widths: ['25%', '25%', '25%', '25%'], body: tentativerealEstateSplitData1}});

              tentativerealEstateSplitData4.push(tentativerealEstateSplitData3);

            });
            //end real estate list view

            //real estate list view
            if(tentativepdfvalue.itemRowsMortgageSplits.length > 1){
              var tentativerealEstateData1 = [];
              var tentativerealEstateData = [];
              tentativerealEstateData.push({text: 'Address : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
              tentativerealEstateData.push({text: tentativepdfvalue.street_number+' '+tentativepdfvalue.street_name+' '+tentativepdfvalue.city+' '+tentativepdfvalue.state+' '+tentativepdfvalue.country+' '+tentativepdfvalue.postcode, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
              tentativerealEstateData.push({text: 'Estimated Current Value : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
              tentativerealEstateData.push({text: '$'+thiss.formatMoney(tentativepdfvalue.asset_value), style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
              tentativerealEstateData1.push(tentativerealEstateData);

               tentativerealEstateData = [];
              tentativerealEstateData.push({text: 'Ownership (Names) : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
              tentativerealEstateData.push({text: tentativepdfvalue.ownership_title_name, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
              tentativerealEstateData.push({text: 'Current Mortgage Limit : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
              tentativerealEstateData.push({text: '$'+thiss.formatMoney(tentativerealEstateTotalSplitMortgageLimit), style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
              tentativerealEstateData1.push(tentativerealEstateData);

               tentativerealEstateData = [];
              tentativerealEstateData.push({text: 'LVR : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
              tentativerealEstateData.push({text: tentativepdfvalue.lvr+'%', style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
              tentativerealEstateData.push({text: 'Funds in Offset or Redraw : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
              tentativerealEstateData.push({text: '$'+thiss.formatMoney(tentativerealEstateTotalSplitCurrentBalance), style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
              tentativerealEstateData1.push(tentativerealEstateData);

               tentativerealEstateData = [];
              tentativerealEstateData.push({text: ' ', style: 'primaryDetails', border: [false, false, false, false]});
              tentativerealEstateData.push({text: '', style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
              tentativerealEstateData.push({text: 'Monthly Repayments', style: 'primaryDetailsMain', border: [false, false, false, false]});
              tentativerealEstateData.push({text: '$'+thiss.formatMoney(tentativerealEstateTotalSplitRepayments), style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
              tentativerealEstateData1.push(tentativerealEstateData);

               tentativerealEstateData = [];
              tentativerealEstateData.push({text: ' ', style: 'primaryDetails', border: [false, false, false, false]});
              tentativerealEstateData.push({text: '', style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
              tentativerealEstateData.push({text: 'Rental Income per week', style: 'primaryDetailsMain', border: [false, false, false, false]});
              tentativerealEstateData.push({text: '$'+thiss.formatMoney(tentativepdfvalue.gross_amount), style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
              tentativerealEstateData1.push(tentativerealEstateData);

               tentativerealEstateData = [];
              tentativerealEstateData.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
              tentativerealEstateData.push({text: '', style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
              tentativerealEstateData.push({text: 'Rent Annual', style: 'primaryDetailsMain', border: [false, false, false, false]});
              tentativerealEstateData.push({text: '$'+thiss.formatMoney(tentativepdfvalue.rent_annual), style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
              tentativerealEstateData1.push(tentativerealEstateData);

              tentativerealEstatePDFListViewAll.push({table: {widths: ['25%', '25%', '25%', '25%'], body: tentativerealEstateSplitData4}, layout: {vLineColor: function(i, node) {return '#f7f7f7';},hLineColor: function(i, node) {return '#f7f7f7;';}}});
              tentativerealEstatePDFListViewAll.push({table: {widths: ['25%', '25%', '25%', '25%'], body: tentativerealEstateData1}, layout: {vLineColor: function(i, node) {return '#f7f7f7';},hLineColor: function(i, node) {return '#f7f7f7;';}}});

              var marginTop = [];
              marginTop.push({text: '', border: [false, false, false, false], margin: [0,0,0,10]});
              tentativerealEstatePDFListViewAll.push({table: {widths: ['100%'], body: marginTop}});

            }else{
              if(tentativepdfkey != thiss.tentativerealestates[0].length-1){
                 tentativerealEstateData1 = [];
                 tentativerealEstateData = [];
                tentativerealEstateData.push({text: 'Address : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
                tentativerealEstateData.push({text: tentativepdfvalue.street_number+' '+tentativepdfvalue.street_name+' '+tentativepdfvalue.city+' '+tentativepdfvalue.state+' '+tentativepdfvalue.country+' '+tentativepdfvalue.postcode, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
                tentativerealEstateData.push({text: 'Estimated Current Value : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
                tentativerealEstateData.push({text: '$'+thiss.formatMoney(tentativepdfvalue.asset_value), style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
                tentativerealEstateData1.push(tentativerealEstateData);

                 tentativerealEstateData = [];
                tentativerealEstateData.push({text: 'Ownership (Names) : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
                tentativerealEstateData.push({text: tentativepdfvalue.ownership_title_name, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
                tentativerealEstateData.push({text: 'Current Mortgage Limit : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
                tentativerealEstateData.push({text: '$'+thiss.formatMoney(tentativerealEstateTotalSplitMortgageLimit), style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
                tentativerealEstateData1.push(tentativerealEstateData);

                 tentativerealEstateData = [];
                tentativerealEstateData.push({text: 'LVR : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
                tentativerealEstateData.push({text: tentativepdfvalue.lvr+'%', style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
                tentativerealEstateData.push({text: 'Funds in Offset or Redraw : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
                tentativerealEstateData.push({text: '$'+thiss.formatMoney(tentativerealEstateTotalSplitCurrentBalance), style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
                tentativerealEstateData1.push(tentativerealEstateData);

                 tentativerealEstateData = [];
                tentativerealEstateData.push({text: 'Lender : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
                tentativerealEstateData.push({text: tentativerealEstateTotalSplitCreditor, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
                tentativerealEstateData.push({text: 'Monthly Repayments : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
                tentativerealEstateData.push({text: '$'+thiss.formatMoney(tentativerealEstateTotalSplitRepayments), style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
                tentativerealEstateData1.push(tentativerealEstateData);

                 tentativerealEstateData = [];
                tentativerealEstateData.push({text: 'Interest Rate : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
                tentativerealEstateData.push({text: tentativerealEstateTotalSplitInterestRate+'%', style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
                tentativerealEstateData.push({text: 'Rental Income per week : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
                tentativerealEstateData.push({text: '$'+thiss.formatMoney(tentativepdfvalue.gross_amount), style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
                tentativerealEstateData1.push(tentativerealEstateData);

                 tentativerealEstateData = [];
                tentativerealEstateData.push({text: 'Fixed or Variable : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
                tentativerealEstateData.push({text: tentativerealEstateTotalSplitInterestRateTerm, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
                tentativerealEstateData.push({text: 'Rent Annual : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
                tentativerealEstateData.push({text: '$'+thiss.formatMoney(tentativepdfvalue.rent_annual), style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
                tentativerealEstateData1.push(tentativerealEstateData);

                 tentativerealEstateData = [];
                tentativerealEstateData.push({text: 'Int Only or P&I : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
                tentativerealEstateData.push({text: tentativerealEstateTotalSplitLoanType, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
                tentativerealEstateData.push({text: '', style: 'primaryDetailsMain', border: [false, false, false, false]});
                tentativerealEstateData.push({text: '', style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
                tentativerealEstateData1.push(tentativerealEstateData);

                tentativerealEstatePDFListViewAll.push({table: {widths: ['25%', '25%', '25%', '25%'], body: tentativerealEstateData1}, layout: {vLineColor: function(i, node) {return '#f7f7f7';},hLineColor: function(i, node) {return '#f7f7f7;';}}});

                 marginTop = [];
                marginTop.push({text: '', border: [false, false, false, false], margin: [0,0,0,10]});
                tentativerealEstatePDFListViewAll.push({table: {widths: ['100%'], body: marginTop}});

              }else{
                 tentativerealEstateData1 = [];

                 tentativerealEstateData = [];
                tentativerealEstateData.push({image: 'data:image/jpeg;base64,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', fit: [250, 150], rowSpan: 8, style: 'totalWithImage', border: [false, false, false, false]});
                tentativerealEstateData.push({text: '', style: 'totalWithImage', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
                tentativerealEstateData.push({text: 'LVR : ', style: 'totalWithImageMain', border: [false, false, false, false]});
                tentativerealEstateData.push({text: tentativepdfvalue.lvr+'%', style: 'totalWithImage', border: [false, false, false, false], alignment: 'right'});
                tentativerealEstateData1.push(tentativerealEstateData);

                 tentativerealEstateData = [];
                tentativerealEstateData.push({text: '', style: 'totalWithImage', border: [false, false, false, false]});
                tentativerealEstateData.push({text: '', style: 'totalWithImage', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
                tentativerealEstateData.push({text: 'Estimated Current Value : ', style: 'totalWithImageMain', border: [false, false, false, false]});
                tentativerealEstateData.push({text: '$'+thiss.formatMoney(tentativepdfvalue.asset_value), style: 'totalWithImage', border: [false, false, false, false], alignment: 'right'});
                tentativerealEstateData1.push(tentativerealEstateData);

                 tentativerealEstateData = [];
                tentativerealEstateData.push({text: '', style: 'totalWithImage', border: [false, false, false, false]});
                tentativerealEstateData.push({text: '', style: 'totalWithImage', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
                tentativerealEstateData.push({text: 'Current Mortgage Limit : ', style: 'totalWithImageMain', border: [false, false, false, false]});
                tentativerealEstateData.push({text: '$'+thiss.formatMoney(tentativepdfvalue.mortgage_limit), style: 'totalWithImage', border: [false, false, false, false], alignment: 'right'});
                tentativerealEstateData1.push(tentativerealEstateData);

                 tentativerealEstateData = [];
                tentativerealEstateData.push({text: '', style: 'totalWithImage', border: [false, false, false, false]});
                tentativerealEstateData.push({text: '', style: 'totalWithImage', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
                tentativerealEstateData.push({text: 'Funds in Offset or Redraw : ', style: 'totalWithImageMain', border: [false, false, false, false]});
                tentativerealEstateData.push({text: '$'+thiss.formatMoney(tentativepdfvalue.current_balance), style: 'totalWithImage', border: [false, false, false, false], alignment: 'right'});
                tentativerealEstateData1.push(tentativerealEstateData);

                 tentativerealEstateData = [];
                tentativerealEstateData.push({text: '', style: 'totalWithImage', border: [false, false, false, false]});
                tentativerealEstateData.push({text: '', style: 'totalWithImage', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
                tentativerealEstateData.push({text: 'Monthly Repayments : ', style: 'totalWithImageMain', border: [false, false, false, false]});
                tentativerealEstateData.push({text: '$'+thiss.formatMoney(tentativepdfvalue.repayments), style: 'totalWithImage', border: [false, false, false, false], alignment: 'right'});
                tentativerealEstateData1.push(tentativerealEstateData);

                 tentativerealEstateData = [];
                tentativerealEstateData.push({text: '', style: 'totalWithImage', border: [false, false, false, false]});
                tentativerealEstateData.push({text: '', style: 'totalWithImage', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
                tentativerealEstateData.push({text: 'Rental Income per week : ', style: 'totalWithImageMain', border: [false, false, false, false]});
                tentativerealEstateData.push({text: '$'+thiss.formatMoney(tentativepdfvalue.gross_amount), style: 'totalWithImage', border: [false, false, false, false], alignment: 'right'});
                tentativerealEstateData1.push(tentativerealEstateData);

                 tentativerealEstateData = [];
                tentativerealEstateData.push({text: '', style: 'totalWithImage', border: [false, false, false, false]});
                tentativerealEstateData.push({text: '', style: 'totalWithImage', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
                tentativerealEstateData.push({text: 'Rent Annual : ', style: 'totalWithImageMain', border: [false, false, false, false]});
                tentativerealEstateData.push({text: '$'+thiss.formatMoney(tentativepdfvalue.rent_annual), style: 'totalWithImage', border: [false, false, false, false], alignment: 'right'});
                tentativerealEstateData1.push(tentativerealEstateData);

                 tentativerealEstateData = [];
                tentativerealEstateData.push({text: '', style: 'totalWithImage', border: [false, false, false, false]});
                tentativerealEstateData.push({text: '', style: 'totalWithImage', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
                tentativerealEstateData.push({text: '', style: 'totalWithImage', border: [false, false, false, false]});
                tentativerealEstateData.push({text: '', style: 'totalWithImage', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
                tentativerealEstateData1.push(tentativerealEstateData);

                tentativerealEstatePDFListViewAll.push({table: {widths: ['25%', '25%', '25%', '25%'], body: tentativerealEstateData1}, layout: {vLineColor: function(i, node) {return '#f7f7f7';},hLineColor: function(i, node) {return '#f7f7f7;';}}});
              }
            }
            //end real estate list view
          }
        });

        tentativerealEstatePDFTableAllData.push({table: {body: tentativerealEstatePDFTableAll}, layout: {vLineColor: function(i, node) {return '#29718c';},hLineColor: function(i, node) {return '#29718c;';}}});
        //end real estate list view
      }else{
         tentativerealEstatePDFTable = [];
         tentativerealEstatePDFListViewAll = [];
        tentativerealEstatePDFTable.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
        tentativerealEstatePDFListViewAll.push({table: {widths: ['100%'], body: tentativerealEstatePDFTable}, layout: {vLineWidth: function(i, node) { return 5; } }});

        tentativerealEstatePDFTable = [];
         tentativerealEstatePDFTableAllData = [];
        tentativerealEstatePDFTable.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
        tentativerealEstatePDFTableAllData.push({table: {widths: ['100%'], body: tentativerealEstatePDFTable}, layout: {vLineWidth: function(i, node) { return 5; } }});
      }
      if(this.showHideTentativetable){
         tentativerealEstatePDFTable = [];
         tentativerealEstatePDFListViewAll = [];
        tentativerealEstatePDFTable.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
        tentativerealEstatePDFListViewAll.push({table: {widths: ['100%'], body: tentativerealEstatePDFTable}, layout: {vLineWidth: function(i, node) { return 5; } }});
      }else{
         tentativerealEstatePDFTable = [];
         tentativerealEstatePDFTableAllData = [];
        tentativerealEstatePDFTable.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
        tentativerealEstatePDFTableAllData.push({table: {widths: ['100%'], body: tentativerealEstatePDFTable}, layout: {vLineWidth: function(i, node) { return 5; } }});
      }
      //end tentative real estate table view

      //income section
      var incomesColumn = [];
      var incomesValue = [];
      var incomesData = [];
      incomesColumn.push({text: 'Type', style: 'primaryIAL', border: [false, false, false, false]});
      incomesColumn.push({text: 'Contact', style: 'primaryIAL', border: [false, false, false, false]});
      incomesColumn.push({text: 'Amount', style: 'primaryIAL', border: [false, false, false, false]});
      incomesColumn.push({text: 'Frequency',style: 'primaryIAL', border: [false, false, false, false]});
      incomesColumn.push({text: 'Date', style: 'primaryIAL', border: [false, false, false, false]});
      incomesColumn.push({text: 'Comments', style: 'primaryIAL', border: [false, false, false, false]});
      incomesData.push(incomesColumn);
      if(this.incomes.length > 0){
        for(var i = 0; i < this.incomes.length; i++){
          incomesValue = [];
          incomesValue.push({text: this.incomes[i].type, style: 'primaryPersonalEmploymenttitle', border: [false, false, false, false]});
          incomesValue.push({text: this.user_data.firstname+' '+this.user_data.lastname, style: 'primaryPersonalEmploymenttitle', border: [false, false, false, false]});
          incomesValue.push({text: this.incomes[i].amount, style: 'primaryPersonalEmploymenttitle', border: [false, false, false, false]});
          incomesValue.push({text: this.incomes[i].frequency, style: 'primaryPersonalEmploymenttitle', border: [false, false, false, false]});
          incomesValue.push({text: this.incomes[i].date_commenced, style: 'primaryPersonalEmploymenttitle', border: [false, false, false, false]});
          incomesValue.push({text: this.incomes[i].comments, style: 'primaryPersonalEmploymenttitle', border: [false, false, false, false]});
          incomesData.push(incomesValue);
        }
      }
      //return false;

      if(this.incomes.length == 0){
        incomesValue = [];
        incomesValue.push({text: 'There are no incomes.',colSpan: 6, style: 'primaryPersonalEmploymenttitle', border: [false, false, false, false]});
        incomesData.push(incomesValue);
      }
      //end income section

      //assets section
      var assetsColumn = [];
      var assetsValue = [];
      var assetsData = [];
      assetsColumn.push({text: 'Asset Type', style: 'primaryIAL', border: [false, false, false, false]});
      assetsColumn.push({text: 'Asset Value', style: 'primaryIAL', border: [false, false, false, false]});
      assetsColumn.push({text: 'Value Basis',style: 'primaryIAL', border: [false, false, false, false]});
      assetsColumn.push({text: 'Ownership', style: 'primaryIAL', border: [false, false, false, false]});
      assetsColumn.push({text: 'Description', style: 'primaryIAL', border: [false, false, false, false]});
      assetsData.push(assetsColumn);
      if(this.assets.length > 0){
        for(var k = 0; k < this.assets.length; k++){
          assetsValue = [];
          assetsValue.push({text: this.assets[k].asset_type, style: 'primaryPersonalEmploymenttitle', border: [false, false, false, false]});
          assetsValue.push({text: this.assets[k].asset_value, style: 'primaryPersonalEmploymenttitle', border: [false, false, false, false]});
          assetsValue.push({text: this.assets[k].value_basis, style: 'primaryPersonalEmploymenttitle', border: [false, false, false, false]});

          let ownershipValue = '';
          ownershipValue += this.user_data.firstname+' '+this.user_data.lastname+ ': '+this.assets[k].percentage_asset+ '% ';
          if(this.secondary_applicant){
          for(var j = 0; j < this.secondary_applicant.length; j++){
            // if(j == 0 && this.assets[k].percentage_asset > 0){
            // }else 
            if(j == 0 && this.assets[k].percentage_asset_0 > 0){
              if(ownershipValue != ''){
                ownershipValue += ' | '
              }
              ownershipValue += this.secondary_applicant[j].user_data.firstname+' '+this.secondary_applicant[j].user_data.lastname+ ': '+this.assets[k].percentage_asset_0+ '%';
            }else if(j == 1 && this.assets[k].percentage_asset_1 > 0){
              if(ownershipValue != ''){
                ownershipValue += ' | '
              }
              ownershipValue += this.secondary_applicant[j].user_data.firstname+' '+this.secondary_applicant[j].user_data.lastname+ ': '+this.assets[k].percentage_asset_0+ '%';
              // ownershipValue += this.user_data.firstname+' '+this.user_data.lastname+ ': '+this.assets[k].percentage_asset_1+ '%';
            }else if(j == 2 && this.assets[k].percentage_asset_2 > 0){
              if(ownershipValue != ''){
                ownershipValue += ' | '
              }
              ownershipValue += this.secondary_applicant[j].user_data.firstname+' '+this.secondary_applicant[j].user_data.lastname+ ': '+this.assets[k].percentage_asset_0+ '%';
              // ownershipValue += this.user_data.firstname+' '+this.user_data.lastname+ ': '+this.assets[k].percentage_asset_2+ '%';
            }else if(j == 3 && this.assets[k].percentage_asset_3 > 0){
              if(ownershipValue != ''){
                ownershipValue += ' | '
              }
              ownershipValue += this.secondary_applicant[j].user_data.firstname+' '+this.secondary_applicant[j].user_data.lastname+ ': '+this.assets[k].percentage_asset_0+ '%';
              // ownershipValue += this.user_data.firstname+' '+this.user_data.lastname+ ': '+this.assets[k].percentage_asset_3+ '%';
            }else if(j == 3 && this.assets[k].percentage_asset_4 > 0){
              if(ownershipValue != ''){
                ownershipValue += ' | '
              }
              ownershipValue += this.secondary_applicant[j].user_data.firstname+' '+this.secondary_applicant[j].user_data.lastname+ ': '+this.assets[k].percentage_asset_0+ '%';
              // ownershipValue += this.user_data.firstname+' '+this.user_data.lastname+ ': '+this.assets[k].percentage_asset_4+ '%';
            }

          }
          }

          assetsValue.push({text: ownershipValue, style: 'primaryPersonalEmploymenttitle', border: [false, false, false, false]});
          assetsValue.push({text: this.assets[k].description, style: 'primaryPersonalEmploymenttitle', border: [false, false, false, false]});
          assetsData.push(assetsValue);
        }
      }
      if(this.assets.length == 0){
        assetsValue = [];
        assetsValue.push({text: 'There are no assets.',colSpan: 5, style: 'primaryPersonalEmploymenttitle', border: [false, false, false, false]});
        assetsData.push(assetsValue);
      }
      //end assets section

      //liabilities section
      var liabilitiesColumn = [];
      var liabilitiesValue = [];
      var liabilitiesData = [];
      liabilitiesColumn.push({text: 'Liability Type', style: 'primaryIAL', border: [false, false, false, false]});
      liabilitiesColumn.push({text: 'Current Balance', style: 'primaryIAL', border: [false, false, false, false]});
      liabilitiesColumn.push({text: 'Limit',style: 'primaryIAL', border: [false, false, false, false]});
      liabilitiesColumn.push({text: 'Description', style: 'primaryIAL', border: [false, false, false, false]});
      liabilitiesData.push(liabilitiesColumn);
      if(this.liabilities.length > 0){
        for(var m = 0; m < this.liabilities.length; m++){
          liabilitiesValue = [];
          liabilitiesValue.push({text: this.liabilities[m].liability_type, style: 'primaryPersonalEmploymenttitle', border: [false, false, false, false]});
          liabilitiesValue.push({text: this.liabilities[m].current_balance, style: 'primaryPersonalEmploymenttitle', border: [false, false, false, false]});
          liabilitiesValue.push({text: this.liabilities[m].limit, style: 'primaryPersonalEmploymenttitle', border: [false, false, false, false]});
          liabilitiesValue.push({text: this.liabilities[m].description, style: 'primaryPersonalEmploymenttitle', border: [false, false, false, false]});
          liabilitiesData.push(liabilitiesValue);
        }
      }
      if(this.liabilities.length == 0){
        liabilitiesValue = [];
        liabilitiesValue.push({text: 'There are no liabilities.',colSpan: 4, style: 'primaryPersonalEmploymenttitle', border: [false, false, false, false]});
        liabilitiesData.push(liabilitiesValue);
      }
      //end liabilities section



      pdfMake.vfs = pdfFonts.pdfMake.vfs;
      this.pdfDoc = {
        //pageSize: {width: 575, height: 850},
        pageSize: 'A4',
        pageMargins: [20, 30, 20, 30],
        dontBreakRows: true,
        content: [
          {
            table: {
              widths: ['100%'],
              body: [
                [{text: 'Primary Contact Details', style: 'primary', border: [false, false, false, false]}]
              ]
            },
            layout: {
              hLineColor: function(i, node) {
                return '#29718c';
              },
              vLineColor: function(i, node) {
                return '#29718c';
              }
            }
          },
          {
            table: {
              widths: ['25%', '25%', '25%', '25%'],
              body: primaryValue
            },
            layout: {
              vLineWidth: function(i, node) {
                return 5;
              }
            }
          },
          secondvalue2,
          realEstatePDFListViewAll,
          realEstatePDFTableAllData,
          tentativerealEstatePDFListViewAll,
          tentativerealEstatePDFTableAllData,
          {
            table: {
              widths: ['100%'],
              body: [
                [{text: 'Income Details', border: [false, false, false, false], margin: [0,20,0,0], bold: true}]
              ]
            }
          },
          {
            table: {
              widths: ['10%', '10%', '15%','15%', '20%', '30%'],
              body: incomesData
            }
          },
          {
            table: {
              widths: ['100%'],
              body: [
                [{text: 'Assets Details', border: [false, false, false, false], margin: [0,20,0,0], bold: true}]
              ]
            }
          },
          {
            table: {
              widths: ['20%', '15%','15%', '20%', '30%'],
              body: assetsData
            }
          },
          {
            table: {
              widths: ['100%'],
              body: [
                [{text: 'Liabilities Details', border: [false, false, false, false], margin: [0,20,0,0], bold: true}]
              ]
            }
          },
          {
            table: {
              widths: ['20%', '25%','25%', '30%'],
              body: liabilitiesData
            }
          },
          {
            table: {
              widths: ['100%'],
              body: [
                [{text: '', border: [false, false, false, false], margin: [0,0,0,20]}]
              ]
            }
          },
          {
            table: {
              widths: ['100%'],
              body: [
                [
                    {text: 'Reason for loan', style:'primary', border: [false, false, false, false]},

                ],
                  [
                    {text: this.user_data.primayr_goal_intention, style: 'primaryPersonalEmploymenttitle', border: [false, false, false, false]},

                ],

              ]
            }
          }
        ],
        styles: {
          header: {
            fontSize: 10,
            bold: true,
            margin: [0, 0, 0, 10],
            borderRadius: [5, 5, 5, 5]
          },
          subheader: {
            fontSize: 10,
            bold: true,
            margin: [0, 10, 0, 5]
          },
          primaryPersonalEmploymenttitleMain: {
            bold: true,
            fillColor: '#fff'
          },
          primaryPersonalEmploymenttitle: {
            margin: [0, 5, 0, 5],
            fontSize: 10,
            fillColor: '#f7f7f7'
          },primaryDetailsMain: {
            fontSize: 10,
            margin: [0, 2, 0, 2],
            fillColor: '#f7f7f7',
            bold: true
          },
          primaryDetails: {
            fontSize: 10,
            margin: [0, 2, 0, 2],
            fillColor: '#f7f7f7'
          },
          realEstateSplitTitle: {
            fontSize: 11,
            margin: [0, 2, 0, 2],
            fillColor: '#eeeeee',
            bold: true
          },
          realEstateSplit1: {
            fontSize: 10,
            margin: [0, 2, 0, 2],
            fillColor: '#eeeeee',
            bold: true
          },
          realEstateSplit: {
            fontSize: 10,
            margin: [0, 2, 0, 2],
            fillColor: '#eeeeee'
          },
          primaryIAL: {
            bold: true,
            fontSize: 10,
            color: 'white',
            fillColor:'#195f79',
            border: [false, false, false, false],
            alignment: 'left',
            margin: [5, 5, 5, 5]
          },
          totalWithImage: {
            fontSize: 10,
            margin: [0, 2, 0, 2],
            fillColor:'#dbeef4'
          },
          totalWithImageMain: {
            fontSize: 10,
            margin: [0, 2, 0, 2],
            fillColor: '#dbeef4',
            bold: true
          },
          primary: {
            bold: true,
            fontSize: 12,
            color: 'white',
            fillColor:'#195f79',
            border: [false, false, false, false],
            alignment: 'left',
            margin: [5, 5, 5, 5]
          },
          tableViewTentativeText: {
            fontSize: 6
          },
          tableViewTentativeText1: {
            fontSize: 6,
            fillColor:'#195f79',
            color: 'white', bold: true,
            hLineColor:['#fff','#fff','#fff','#fff']
          },
          customerTag: {
            fillColor:'#195f79',
            color: 'white', bold: true,
            fontSize: 10,
          }
        },
        defaultStyle: {
          // alignment: 'justify'
        }
      }
      //return false;
      let d = new Date(); // for now
      let pdfName = d.getDate() + "-" + (d.getMonth()+1) + "-" + d.getFullYear();
      if(this.user_data.firstname == "" || this.user_data.firstname == null || this.user_data.firstname == undefined){}else{
        pdfName += ' - '+this.user_data.firstname+' '+this.user_data.lastname;
      }

      // if(customName != undefined && customName.length > 0){
      //   pdfName += ' '+customName[0].firstname+' '+customName[0].lastname;
      // }
      //pdfName += '.pdf';
      pdfMake.createPdf(this.pdfDoc).download(pdfName+'.pdf');
    });


  }

  downloadPdf_1() {

   let elementid = document.getElementById('content')

  // var fullText = "";

  //   var x = $(elementid).children();
  //   $.each(x, function(index, value) {
  //      //console.log(value);
  //       fullText+=$(this).cont
  //       console.log($(this).context.innerText);
  //   });
    
    html2canvas(elementid, { 
      allowTaint: true,
      useCORS: true,
      logging: false,
      height: window.outerHeight + window.innerHeight,
      windowHeight: window.outerHeight + window.innerHeight, 
     }).then(canvas => {
      var data = canvas.toDataURL("image/png");

      var docDefinition = {                      
          content: [
              {
                  image: data,
                  width: 525,
                  alignment: "center"
              }
          ],
          pageSize: "letter",
          pageOrientation: "portrait",
          styles: {
              footer: {
                  fontSize: 8,
                  alignment: "center",
                  margin: [0, 0, 0, 80]
  }
          }
      };
          let d = new Date(); // for now
          let pdfName = d.getDate() + "-" + (d.getMonth()+1) + "-" + d.getFullYear();

      pdfMake.createPdf(docDefinition).download(pdfName+'.pdf');
    });

  }

  getDimensionsByFilter(group_id, data){
    return data.filter(x => x.group_id === group_id);
  }

  hideShowTableListView(status){
    if(status){
      this.showHideTentativetable = false;
      this.showHideTentativetableIcon = 'apps';
    }else{
      this.showHideTentativetable = true;
      this.showHideTentativetableIcon = 'add';
    }
  }

  hideShowTableListViewReal(status){
    if(status){
      this.showHideRealtable = false;
      this.showHideRealtableIcon = 'apps';
    }else{
      this.showHideRealtable = true;
      this.showHideRealtableIcon = 'add';
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/view-contact-pdf/view-contact-pdf.ts